/**
 * 급여 구간별 세금 테이블
 * 
 * 원본: src/const_PayrollManagement.js
 * 이동일: 2026-01-11
 * 
 * @description 급여 구간(min~max)별 부양가족 수에 따른 세금 정보
 * taxes 배열: [0명, 1명, 2명, 3명, 4명, 5명, 6명, 7명, 8명, 9명, 10명]
 */

export interface TaxBracket {
  /** 급여 구간 최소값 (천원 단위) */
  min: number;
  /** 급여 구간 최대값 (천원 단위) */
  max: number;
  /** 부양가족 수별 세금액 (11개 항목: 0~10명) */
  taxes: number[];
}

export const defaultTaxTable: TaxBracket[] = [
  {
    "min": 770,
    "max": 775,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 775,
    "max": 780,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 780,
    "max": 785,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 785,
    "max": 790,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 790,
    "max": 795,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 795,
    "max": 800,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 800,
    "max": 805,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 805,
    "max": 810,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 810,
    "max": 815,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 815,
    "max": 820,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 820,
    "max": 825,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 825,
    "max": 830,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 830,
    "max": 835,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 835,
    "max": 840,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 840,
    "max": 845,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 845,
    "max": 850,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 850,
    "max": 855,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 855,
    "max": 860,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 860,
    "max": 865,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 865,
    "max": 870,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 870,
    "max": 875,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 875,
    "max": 880,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 880,
    "max": 885,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 885,
    "max": 890,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 890,
    "max": 895,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 895,
    "max": 900,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 900,
    "max": 905,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 905,
    "max": 910,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 910,
    "max": 915,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 915,
    "max": 920,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 920,
    "max": 925,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 925,
    "max": 930,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 930,
    "max": 935,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 935,
    "max": 940,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 940,
    "max": 945,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 945,
    "max": 950,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 950,
    "max": 955,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 955,
    "max": 960,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 960,
    "max": 965,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 965,
    "max": 970,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 970,
    "max": 975,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 975,
    "max": 980,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 980,
    "max": 985,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 985,
    "max": 990,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 990,
    "max": 995,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 995,
    "max": 1000,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1000,
    "max": 1005,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1005,
    "max": 1010,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1010,
    "max": 1015,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1015,
    "max": 1020,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1020,
    "max": 1025,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1025,
    "max": 1030,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1030,
    "max": 1035,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1035,
    "max": 1040,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1040,
    "max": 1045,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1045,
    "max": 1050,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1050,
    "max": 1055,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1055,
    "max": 1060,
    "taxes": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1060,
    "max": 1065,
    "taxes": [
      1040,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1065,
    "max": 1070,
    "taxes": [
      1110,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1070,
    "max": 1075,
    "taxes": [
      1180,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1075,
    "max": 1080,
    "taxes": [
      1250,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1080,
    "max": 1085,
    "taxes": [
      1320,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1085,
    "max": 1090,
    "taxes": [
      1390,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1090,
    "max": 1095,
    "taxes": [
      1460,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1095,
    "max": 1100,
    "taxes": [
      1530,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1100,
    "max": 1105,
    "taxes": [
      1600,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1105,
    "max": 1110,
    "taxes": [
      1670,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1110,
    "max": 1115,
    "taxes": [
      1740,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1115,
    "max": 1120,
    "taxes": [
      1810,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1120,
    "max": 1125,
    "taxes": [
      1880,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1125,
    "max": 1130,
    "taxes": [
      1950,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1130,
    "max": 1135,
    "taxes": [
      2020,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1135,
    "max": 1140,
    "taxes": [
      2090,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1140,
    "max": 1145,
    "taxes": [
      2160,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1145,
    "max": 1150,
    "taxes": [
      2230,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1150,
    "max": 1155,
    "taxes": [
      2300,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1155,
    "max": 1160,
    "taxes": [
      2370,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1160,
    "max": 1165,
    "taxes": [
      2440,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1165,
    "max": 1170,
    "taxes": [
      2500,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1170,
    "max": 1175,
    "taxes": [
      2570,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1175,
    "max": 1180,
    "taxes": [
      2640,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1180,
    "max": 1185,
    "taxes": [
      2710,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1185,
    "max": 1190,
    "taxes": [
      2780,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1190,
    "max": 1195,
    "taxes": [
      2850,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1195,
    "max": 1200,
    "taxes": [
      2920,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1200,
    "max": 1205,
    "taxes": [
      2990,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1205,
    "max": 1210,
    "taxes": [
      3060,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1210,
    "max": 1215,
    "taxes": [
      3130,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1215,
    "max": 1220,
    "taxes": [
      3200,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1220,
    "max": 1225,
    "taxes": [
      3270,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1225,
    "max": 1230,
    "taxes": [
      3340,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1230,
    "max": 1235,
    "taxes": [
      3410,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1235,
    "max": 1240,
    "taxes": [
      3480,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1240,
    "max": 1245,
    "taxes": [
      3550,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1245,
    "max": 1250,
    "taxes": [
      3620,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1250,
    "max": 1255,
    "taxes": [
      3700,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1255,
    "max": 1260,
    "taxes": [
      3810,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1260,
    "max": 1265,
    "taxes": [
      3910,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1265,
    "max": 1270,
    "taxes": [
      4010,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1270,
    "max": 1275,
    "taxes": [
      4120,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1275,
    "max": 1280,
    "taxes": [
      4220,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1280,
    "max": 1285,
    "taxes": [
      4320,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1285,
    "max": 1290,
    "taxes": [
      4430,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1290,
    "max": 1295,
    "taxes": [
      4530,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1295,
    "max": 1300,
    "taxes": [
      4630,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1300,
    "max": 1305,
    "taxes": [
      4740,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1305,
    "max": 1310,
    "taxes": [
      4840,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1310,
    "max": 1315,
    "taxes": [
      4940,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1315,
    "max": 1320,
    "taxes": [
      5050,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1320,
    "max": 1325,
    "taxes": [
      5150,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1325,
    "max": 1330,
    "taxes": [
      5250,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1330,
    "max": 1335,
    "taxes": [
      5360,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1335,
    "max": 1340,
    "taxes": [
      5460,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1340,
    "max": 1345,
    "taxes": [
      5560,
      1060,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1345,
    "max": 1350,
    "taxes": [
      5670,
      1170,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1350,
    "max": 1355,
    "taxes": [
      5770,
      1270,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1355,
    "max": 1360,
    "taxes": [
      5870,
      1370,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1360,
    "max": 1365,
    "taxes": [
      5980,
      1480,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1365,
    "max": 1370,
    "taxes": [
      6080,
      1580,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1370,
    "max": 1375,
    "taxes": [
      6180,
      1680,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1375,
    "max": 1380,
    "taxes": [
      6290,
      1790,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1380,
    "max": 1385,
    "taxes": [
      6390,
      1890,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1385,
    "max": 1390,
    "taxes": [
      6490,
      1990,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1390,
    "max": 1395,
    "taxes": [
      6600,
      2100,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1395,
    "max": 1400,
    "taxes": [
      6700,
      2200,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1400,
    "max": 1405,
    "taxes": [
      6800,
      2300,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1405,
    "max": 1410,
    "taxes": [
      6910,
      2410,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1410,
    "max": 1415,
    "taxes": [
      7010,
      2510,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1415,
    "max": 1420,
    "taxes": [
      7110,
      2610,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1420,
    "max": 1425,
    "taxes": [
      7210,
      2710,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1425,
    "max": 1430,
    "taxes": [
      7320,
      2820,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1430,
    "max": 1435,
    "taxes": [
      7420,
      2920,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1435,
    "max": 1440,
    "taxes": [
      7520,
      3020,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1440,
    "max": 1445,
    "taxes": [
      7630,
      3130,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1445,
    "max": 1450,
    "taxes": [
      7730,
      3230,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1450,
    "max": 1455,
    "taxes": [
      7830,
      3330,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1455,
    "max": 1460,
    "taxes": [
      7940,
      3440,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1460,
    "max": 1465,
    "taxes": [
      8040,
      3540,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1465,
    "max": 1470,
    "taxes": [
      8140,
      3640,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1470,
    "max": 1475,
    "taxes": [
      8250,
      3750,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1475,
    "max": 1480,
    "taxes": [
      8350,
      3850,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1480,
    "max": 1485,
    "taxes": [
      8450,
      3950,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1485,
    "max": 1490,
    "taxes": [
      8560,
      4060,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1490,
    "max": 1495,
    "taxes": [
      8660,
      4160,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1495,
    "max": 1500,
    "taxes": [
      8760,
      4260,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1500,
    "max": 1510,
    "taxes": [
      8920,
      4420,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1510,
    "max": 1520,
    "taxes": [
      9120,
      4620,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1520,
    "max": 1530,
    "taxes": [
      9330,
      4830,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1530,
    "max": 1540,
    "taxes": [
      9540,
      5040,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1540,
    "max": 1550,
    "taxes": [
      9740,
      5240,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1550,
    "max": 1560,
    "taxes": [
      9950,
      5450,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1560,
    "max": 1570,
    "taxes": [
      10160,
      5660,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1570,
    "max": 1580,
    "taxes": [
      10360,
      5860,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1580,
    "max": 1590,
    "taxes": [
      10570,
      6070,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1590,
    "max": 1600,
    "taxes": [
      10780,
      6280,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1600,
    "max": 1610,
    "taxes": [
      10980,
      6480,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1610,
    "max": 1620,
    "taxes": [
      11190,
      6690,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1620,
    "max": 1630,
    "taxes": [
      11400,
      6900,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1630,
    "max": 1640,
    "taxes": [
      11600,
      7100,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1640,
    "max": 1650,
    "taxes": [
      11810,
      7310,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1650,
    "max": 1660,
    "taxes": [
      12020,
      7520,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1660,
    "max": 1670,
    "taxes": [
      12220,
      7720,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1670,
    "max": 1680,
    "taxes": [
      12430,
      7930,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1680,
    "max": 1690,
    "taxes": [
      12640,
      8140,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1690,
    "max": 1700,
    "taxes": [
      12840,
      8340,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1700,
    "max": 1710,
    "taxes": [
      13050,
      8550,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1710,
    "max": 1720,
    "taxes": [
      13260,
      8760,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1720,
    "max": 1730,
    "taxes": [
      13460,
      8960,
      1040,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1730,
    "max": 1740,
    "taxes": [
      13670,
      9170,
      1240,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1740,
    "max": 1750,
    "taxes": [
      13880,
      9380,
      1440,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1750,
    "max": 1760,
    "taxes": [
      14080,
      9580,
      1640,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1760,
    "max": 1770,
    "taxes": [
      14290,
      9790,
      1830,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1770,
    "max": 1780,
    "taxes": [
      14500,
      10000,
      2030,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1780,
    "max": 1790,
    "taxes": [
      14700,
      10200,
      2230,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1790,
    "max": 1800,
    "taxes": [
      14910,
      10410,
      2430,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1800,
    "max": 1810,
    "taxes": [
      15110,
      10610,
      2630,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1810,
    "max": 1820,
    "taxes": [
      15320,
      10820,
      2830,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1820,
    "max": 1830,
    "taxes": [
      15530,
      11030,
      3020,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1830,
    "max": 1840,
    "taxes": [
      15730,
      11230,
      3220,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1840,
    "max": 1850,
    "taxes": [
      15940,
      11440,
      3420,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1850,
    "max": 1860,
    "taxes": [
      16150,
      11650,
      3620,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1860,
    "max": 1870,
    "taxes": [
      16350,
      11850,
      3820,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1870,
    "max": 1880,
    "taxes": [
      16560,
      12060,
      4020,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1880,
    "max": 1890,
    "taxes": [
      16770,
      12270,
      4220,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1890,
    "max": 1900,
    "taxes": [
      16970,
      12470,
      4410,
      1040,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1900,
    "max": 1910,
    "taxes": [
      17180,
      12680,
      4610,
      1240,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1910,
    "max": 1920,
    "taxes": [
      17390,
      12890,
      4810,
      1440,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1920,
    "max": 1930,
    "taxes": [
      17590,
      13090,
      5010,
      1630,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1930,
    "max": 1940,
    "taxes": [
      17800,
      13300,
      5210,
      1830,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1940,
    "max": 1950,
    "taxes": [
      18010,
      13510,
      5410,
      2030,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1950,
    "max": 1960,
    "taxes": [
      18210,
      13710,
      5600,
      2230,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1960,
    "max": 1970,
    "taxes": [
      18420,
      13920,
      5800,
      2430,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1970,
    "max": 1980,
    "taxes": [
      18630,
      14130,
      6000,
      2630,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1980,
    "max": 1990,
    "taxes": [
      18880,
      14330,
      6200,
      2820,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 1990,
    "max": 2000,
    "taxes": [
      19200,
      14540,
      6400,
      3020,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2000,
    "max": 2010,
    "taxes": [
      19520,
      14750,
      6600,
      3220,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2010,
    "max": 2020,
    "taxes": [
      19850,
      14950,
      6800,
      3420,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2020,
    "max": 2030,
    "taxes": [
      20170,
      15160,
      6990,
      3620,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2030,
    "max": 2040,
    "taxes": [
      20490,
      15370,
      7190,
      3820,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2040,
    "max": 2050,
    "taxes": [
      20810,
      15570,
      7390,
      4020,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2050,
    "max": 2060,
    "taxes": [
      21130,
      15780,
      7590,
      4210,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2060,
    "max": 2070,
    "taxes": [
      21450,
      15990,
      7790,
      4410,
      1040,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2070,
    "max": 2080,
    "taxes": [
      21770,
      16190,
      7990,
      4610,
      1240,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2080,
    "max": 2090,
    "taxes": [
      22090,
      16400,
      8180,
      4810,
      1430,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2090,
    "max": 2100,
    "taxes": [
      22420,
      16600,
      8380,
      5010,
      1630,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2100,
    "max": 2110,
    "taxes": [
      22740,
      16810,
      8580,
      5210,
      1830,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2110,
    "max": 2120,
    "taxes": [
      23060,
      17020,
      8780,
      5400,
      2030,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2120,
    "max": 2130,
    "taxes": [
      23380,
      17220,
      8980,
      5600,
      2230,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2130,
    "max": 2140,
    "taxes": [
      23700,
      17430,
      9180,
      5800,
      2430,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2140,
    "max": 2150,
    "taxes": [
      24020,
      17640,
      9380,
      6000,
      2630,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2150,
    "max": 2160,
    "taxes": [
      24340,
      17840,
      9570,
      6200,
      2820,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2160,
    "max": 2170,
    "taxes": [
      24660,
      18050,
      9770,
      6400,
      3020,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2170,
    "max": 2180,
    "taxes": [
      24990,
      18260,
      9970,
      6600,
      3220,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2180,
    "max": 2190,
    "taxes": [
      25310,
      18460,
      10170,
      6790,
      3420,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2190,
    "max": 2200,
    "taxes": [
      25630,
      18670,
      10370,
      6990,
      3620,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2200,
    "max": 2210,
    "taxes": [
      25950,
      18950,
      10570,
      7190,
      3820,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2210,
    "max": 2220,
    "taxes": [
      26270,
      19270,
      10760,
      7390,
      4010,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2220,
    "max": 2230,
    "taxes": [
      26590,
      19590,
      10960,
      7590,
      4210,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2230,
    "max": 2240,
    "taxes": [
      26910,
      19910,
      11160,
      7790,
      4410,
      1040,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2240,
    "max": 2250,
    "taxes": [
      27240,
      20240,
      11360,
      7980,
      4610,
      1230,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2250,
    "max": 2260,
    "taxes": [
      27560,
      20560,
      11560,
      8180,
      4810,
      1430,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2260,
    "max": 2270,
    "taxes": [
      27880,
      20880,
      11760,
      8380,
      5010,
      1630,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2270,
    "max": 2280,
    "taxes": [
      28200,
      21200,
      11960,
      8580,
      5210,
      1830,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2280,
    "max": 2290,
    "taxes": [
      28520,
      21520,
      12150,
      8780,
      5400,
      2030,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2290,
    "max": 2300,
    "taxes": [
      28840,
      21840,
      12350,
      8980,
      5600,
      2230,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2300,
    "max": 2310,
    "taxes": [
      29160,
      22160,
      12550,
      9180,
      5800,
      2430,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2310,
    "max": 2320,
    "taxes": [
      29480,
      22480,
      12750,
      9370,
      6000,
      2620,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2320,
    "max": 2330,
    "taxes": [
      29810,
      22810,
      12950,
      9570,
      6200,
      2820,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2330,
    "max": 2340,
    "taxes": [
      30130,
      23130,
      13150,
      9770,
      6400,
      3020,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2340,
    "max": 2350,
    "taxes": [
      30450,
      23450,
      13340,
      9970,
      6590,
      3220,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2350,
    "max": 2360,
    "taxes": [
      30770,
      23770,
      13540,
      10170,
      6790,
      3420,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2360,
    "max": 2370,
    "taxes": [
      31090,
      24090,
      13740,
      10370,
      6990,
      3620,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2370,
    "max": 2380,
    "taxes": [
      31410,
      24410,
      13940,
      10560,
      7190,
      3810,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2380,
    "max": 2390,
    "taxes": [
      31730,
      24730,
      14140,
      10760,
      7390,
      4010,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2390,
    "max": 2400,
    "taxes": [
      32050,
      25050,
      14340,
      10960,
      7590,
      4210,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2400,
    "max": 2410,
    "taxes": [
      32380,
      25380,
      14530,
      11160,
      7780,
      4410,
      1030,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2410,
    "max": 2420,
    "taxes": [
      32700,
      25700,
      14730,
      11360,
      7980,
      4610,
      1230,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2420,
    "max": 2430,
    "taxes": [
      33020,
      26020,
      14930,
      11560,
      8180,
      4810,
      1430,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2430,
    "max": 2440,
    "taxes": [
      33340,
      26340,
      15130,
      11760,
      8380,
      5010,
      1630,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2440,
    "max": 2450,
    "taxes": [
      33660,
      26660,
      15330,
      11950,
      8580,
      5200,
      1830,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2450,
    "max": 2460,
    "taxes": [
      33980,
      26980,
      15530,
      12150,
      8780,
      5400,
      2030,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2460,
    "max": 2470,
    "taxes": [
      34300,
      27300,
      15730,
      12350,
      8980,
      5600,
      2230,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2470,
    "max": 2480,
    "taxes": [
      34630,
      27630,
      15920,
      12550,
      9170,
      5800,
      2420,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2480,
    "max": 2490,
    "taxes": [
      34950,
      27950,
      16120,
      12750,
      9370,
      6000,
      2620,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2490,
    "max": 2500,
    "taxes": [
      35270,
      28270,
      16320,
      12950,
      9570,
      6200,
      2820,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2500,
    "max": 2510,
    "taxes": [
      35600,
      28600,
      16530,
      13150,
      9780,
      6400,
      3030,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2510,
    "max": 2520,
    "taxes": [
      35940,
      28940,
      16740,
      13360,
      9990,
      6610,
      3240,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2520,
    "max": 2530,
    "taxes": [
      36280,
      29280,
      16950,
      13580,
      10200,
      6830,
      3450,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2530,
    "max": 2540,
    "taxes": [
      36630,
      29630,
      17160,
      13790,
      10410,
      7040,
      3660,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2540,
    "max": 2550,
    "taxes": [
      36970,
      29970,
      17370,
      14000,
      10620,
      7250,
      3870,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2550,
    "max": 2560,
    "taxes": [
      37310,
      30310,
      17590,
      14210,
      10840,
      7460,
      4090,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2560,
    "max": 2570,
    "taxes": [
      37650,
      30650,
      17800,
      14420,
      11050,
      7670,
      4300,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 2570,
    "max": 2580,
    "taxes": [
      38000,
      31000,
      18010,
      14630,
      11260,
      7880,
      4510,
      1130,
      0,
      0,
      0
    ]
  },
  {
    "min": 2580,
    "max": 2590,
    "taxes": [
      38340,
      31340,
      18220,
      14850,
      11470,
      8100,
      4720,
      1350,
      0,
      0,
      0
    ]
  },
  {
    "min": 2590,
    "max": 2600,
    "taxes": [
      38830,
      31680,
      18430,
      15060,
      11680,
      8310,
      4930,
      1560,
      0,
      0,
      0
    ]
  },
  {
    "min": 2600,
    "max": 2610,
    "taxes": [
      39690,
      32020,
      18650,
      15270,
      11900,
      8520,
      5150,
      1770,
      0,
      0,
      0
    ]
  },
  {
    "min": 2610,
    "max": 2620,
    "taxes": [
      40540,
      32360,
      18920,
      15480,
      12110,
      8730,
      5360,
      1980,
      0,
      0,
      0
    ]
  },
  {
    "min": 2620,
    "max": 2630,
    "taxes": [
      41400,
      32710,
      19250,
      15690,
      12320,
      8940,
      5570,
      2190,
      0,
      0,
      0
    ]
  },
  {
    "min": 2630,
    "max": 2640,
    "taxes": [
      42260,
      33050,
      19580,
      15910,
      12530,
      9160,
      5780,
      2410,
      0,
      0,
      0
    ]
  },
  {
    "min": 2640,
    "max": 2650,
    "taxes": [
      43110,
      33390,
      19910,
      16120,
      12740,
      9370,
      5990,
      2620,
      0,
      0,
      0
    ]
  },
  {
    "min": 2650,
    "max": 2660,
    "taxes": [
      43970,
      33730,
      20240,
      16330,
      12960,
      9580,
      6210,
      2830,
      0,
      0,
      0
    ]
  },
  {
    "min": 2660,
    "max": 2670,
    "taxes": [
      44820,
      34080,
      20570,
      16540,
      13170,
      9790,
      6420,
      3040,
      0,
      0,
      0
    ]
  },
  {
    "min": 2670,
    "max": 2680,
    "taxes": [
      45680,
      34420,
      20900,
      16750,
      13380,
      10000,
      6630,
      3250,
      0,
      0,
      0
    ]
  },
  {
    "min": 2680,
    "max": 2690,
    "taxes": [
      46540,
      34760,
      21230,
      16970,
      13590,
      10220,
      6840,
      3470,
      0,
      0,
      0
    ]
  },
  {
    "min": 2690,
    "max": 2700,
    "taxes": [
      47390,
      35100,
      21560,
      17180,
      13800,
      10430,
      7050,
      3680,
      0,
      0,
      0
    ]
  },
  {
    "min": 2700,
    "max": 2710,
    "taxes": [
      48250,
      35450,
      21890,
      17390,
      14020,
      10640,
      7270,
      3890,
      0,
      0,
      0
    ]
  },
  {
    "min": 2710,
    "max": 2720,
    "taxes": [
      49100,
      35790,
      22220,
      17600,
      14230,
      10850,
      7480,
      4100,
      0,
      0,
      0
    ]
  },
  {
    "min": 2720,
    "max": 2730,
    "taxes": [
      49960,
      36130,
      22550,
      17810,
      14440,
      11060,
      7690,
      4310,
      0,
      0,
      0
    ]
  },
  {
    "min": 2730,
    "max": 2740,
    "taxes": [
      50810,
      36470,
      22880,
      18030,
      14650,
      11280,
      7900,
      4530,
      1150,
      0,
      0
    ]
  },
  {
    "min": 2740,
    "max": 2750,
    "taxes": [
      51670,
      36810,
      23210,
      18240,
      14860,
      11490,
      8110,
      4740,
      1360,
      0,
      0
    ]
  },
  {
    "min": 2750,
    "max": 2760,
    "taxes": [
      52530,
      37160,
      23540,
      18450,
      15070,
      11700,
      8320,
      4950,
      1570,
      0,
      0
    ]
  },
  {
    "min": 2760,
    "max": 2770,
    "taxes": [
      53380,
      37500,
      23870,
      18660,
      15290,
      11910,
      8540,
      5160,
      1790,
      0,
      0
    ]
  },
  {
    "min": 2770,
    "max": 2780,
    "taxes": [
      54240,
      37840,
      24200,
      18950,
      15500,
      12120,
      8750,
      5370,
      2000,
      0,
      0
    ]
  },
  {
    "min": 2780,
    "max": 2790,
    "taxes": [
      55090,
      38180,
      24520,
      19270,
      15710,
      12340,
      8960,
      5590,
      2210,
      0,
      0
    ]
  },
  {
    "min": 2790,
    "max": 2800,
    "taxes": [
      55950,
      38530,
      24850,
      19600,
      15920,
      12550,
      9170,
      5800,
      2420,
      0,
      0
    ]
  },
  {
    "min": 2800,
    "max": 2810,
    "taxes": [
      56800,
      39300,
      25180,
      19930,
      16130,
      12760,
      9380,
      6010,
      2630,
      0,
      0
    ]
  },
  {
    "min": 2810,
    "max": 2820,
    "taxes": [
      57660,
      40160,
      25510,
      20260,
      16350,
      12970,
      9600,
      6220,
      2850,
      0,
      0
    ]
  },
  {
    "min": 2820,
    "max": 2830,
    "taxes": [
      58520,
      41020,
      25840,
      20590,
      16560,
      13180,
      9810,
      6430,
      3060,
      0,
      0
    ]
  },
  {
    "min": 2830,
    "max": 2840,
    "taxes": [
      59370,
      41870,
      26170,
      20920,
      16770,
      13400,
      10020,
      6650,
      3270,
      0,
      0
    ]
  },
  {
    "min": 2840,
    "max": 2850,
    "taxes": [
      60230,
      42730,
      26500,
      21250,
      16980,
      13610,
      10230,
      6860,
      3480,
      0,
      0
    ]
  },
  {
    "min": 2850,
    "max": 2860,
    "taxes": [
      61080,
      43580,
      26830,
      21580,
      17190,
      13820,
      10440,
      7070,
      3690,
      0,
      0
    ]
  },
  {
    "min": 2860,
    "max": 2870,
    "taxes": [
      61940,
      44440,
      27160,
      21910,
      17410,
      14030,
      10660,
      7280,
      3910,
      0,
      0
    ]
  },
  {
    "min": 2870,
    "max": 2880,
    "taxes": [
      62790,
      45290,
      27490,
      22240,
      17620,
      14240,
      10870,
      7490,
      4120,
      0,
      0
    ]
  },
  {
    "min": 2880,
    "max": 2890,
    "taxes": [
      63650,
      46150,
      27820,
      22570,
      17830,
      14460,
      11080,
      7710,
      4330,
      0,
      0
    ]
  },
  {
    "min": 2890,
    "max": 2900,
    "taxes": [
      64510,
      47010,
      28150,
      22900,
      18040,
      14670,
      11290,
      7920,
      4540,
      1170,
      0
    ]
  },
  {
    "min": 2900,
    "max": 2910,
    "taxes": [
      65360,
      47860,
      28480,
      23230,
      18250,
      14880,
      11500,
      8130,
      4750,
      1380,
      0
    ]
  },
  {
    "min": 2910,
    "max": 2920,
    "taxes": [
      66220,
      48720,
      28810,
      23560,
      18470,
      15090,
      11720,
      8340,
      4970,
      1590,
      0
    ]
  },
  {
    "min": 2920,
    "max": 2930,
    "taxes": [
      67070,
      49570,
      29140,
      23890,
      18680,
      15300,
      11930,
      8550,
      5180,
      1800,
      0
    ]
  },
  {
    "min": 2930,
    "max": 2940,
    "taxes": [
      67930,
      50430,
      29470,
      24220,
      18970,
      15510,
      12140,
      8760,
      5390,
      2010,
      0
    ]
  },
  {
    "min": 2940,
    "max": 2950,
    "taxes": [
      68780,
      51280,
      29800,
      24550,
      19300,
      15730,
      12350,
      8980,
      5600,
      2230,
      0
    ]
  },
  {
    "min": 2950,
    "max": 2960,
    "taxes": [
      69640,
      52140,
      30130,
      24880,
      19630,
      15940,
      12560,
      9190,
      5810,
      2440,
      0
    ]
  },
  {
    "min": 2960,
    "max": 2970,
    "taxes": [
      70500,
      53000,
      30460,
      25210,
      19960,
      16150,
      12780,
      9400,
      6030,
      2650,
      0
    ]
  },
  {
    "min": 2970,
    "max": 2980,
    "taxes": [
      71350,
      53850,
      30790,
      25540,
      20290,
      16360,
      12990,
      9610,
      6240,
      2860,
      0
    ]
  },
  {
    "min": 2980,
    "max": 2990,
    "taxes": [
      72210,
      54710,
      31120,
      25870,
      20620,
      16570,
      13200,
      9820,
      6450,
      3070,
      0
    ]
  },
  {
    "min": 2990,
    "max": 3000,
    "taxes": [
      73060,
      55560,
      31450,
      26200,
      20950,
      16790,
      13410,
      10040,
      6660,
      3290,
      0
    ]
  },
  {
    "min": 3000,
    "max": 3020,
    "taxes": [
      74350,
      56850,
      31940,
      26690,
      21440,
      17100,
      13730,
      10350,
      6980,
      3600,
      0
    ]
  },
  {
    "min": 3020,
    "max": 3040,
    "taxes": [
      76060,
      58560,
      32600,
      27350,
      22100,
      17530,
      14150,
      10780,
      7400,
      4030,
      0
    ]
  },
  {
    "min": 3040,
    "max": 3060,
    "taxes": [
      77770,
      60270,
      33260,
      28010,
      22760,
      17950,
      14580,
      11200,
      7830,
      4450,
      1080
    ]
  },
  {
    "min": 3060,
    "max": 3080,
    "taxes": [
      79480,
      61980,
      33920,
      28670,
      23420,
      18380,
      15000,
      11630,
      8250,
      4880,
      1500
    ]
  },
  {
    "min": 3080,
    "max": 3100,
    "taxes": [
      81190,
      63690,
      34580,
      29330,
      24080,
      18830,
      15430,
      12050,
      8680,
      5300,
      1930
    ]
  },
  {
    "min": 3100,
    "max": 3120,
    "taxes": [
      82900,
      65400,
      35240,
      29990,
      24740,
      19490,
      15850,
      12470,
      9100,
      5720,
      2350
    ]
  },
  {
    "min": 3120,
    "max": 3140,
    "taxes": [
      84620,
      67120,
      35900,
      30650,
      25400,
      20150,
      16270,
      12900,
      9520,
      6150,
      2770
    ]
  },
  {
    "min": 3140,
    "max": 3160,
    "taxes": [
      86330,
      68830,
      36560,
      31310,
      26060,
      20810,
      16700,
      13320,
      9950,
      6570,
      3200
    ]
  },
  {
    "min": 3160,
    "max": 3180,
    "taxes": [
      88040,
      70540,
      37220,
      31970,
      26720,
      21470,
      17120,
      13750,
      10370,
      7000,
      3620
    ]
  },
  {
    "min": 3180,
    "max": 3200,
    "taxes": [
      89750,
      72250,
      37880,
      32630,
      27380,
      22130,
      17540,
      14170,
      10790,
      7420,
      4040
    ]
  },
  {
    "min": 3200,
    "max": 3220,
    "taxes": [
      91460,
      73960,
      38540,
      33290,
      28040,
      22790,
      17970,
      14590,
      11220,
      7840,
      4470
    ]
  },
  {
    "min": 3220,
    "max": 3240,
    "taxes": [
      93170,
      75670,
      40120,
      33950,
      28700,
      23450,
      18390,
      15020,
      11640,
      8270,
      4890
    ]
  },
  {
    "min": 3240,
    "max": 3260,
    "taxes": [
      95430,
      77380,
      41770,
      34610,
      29360,
      24110,
      18860,
      15440,
      12070,
      8690,
      5320
    ]
  },
  {
    "min": 3260,
    "max": 3280,
    "taxes": [
      97880,
      79100,
      43420,
      35270,
      30020,
      24770,
      19520,
      15870,
      12490,
      9120,
      5740
    ]
  },
  {
    "min": 3280,
    "max": 3300,
    "taxes": [
      100320,
      80810,
      45070,
      35920,
      30670,
      25420,
      20170,
      16290,
      12910,
      9540,
      6160
    ]
  },
  {
    "min": 3300,
    "max": 3320,
    "taxes": [
      102770,
      82520,
      46720,
      36580,
      31330,
      26080,
      20830,
      16710,
      13340,
      9960,
      6590
    ]
  },
  {
    "min": 3320,
    "max": 3340,
    "taxes": [
      105210,
      84230,
      48370,
      37240,
      31990,
      26740,
      21490,
      17140,
      13760,
      10390,
      7010
    ]
  },
  {
    "min": 3340,
    "max": 3360,
    "taxes": [
      107660,
      85940,
      49940,
      37870,
      32620,
      27370,
      22120,
      17540,
      14170,
      10790,
      7420
    ]
  },
  {
    "min": 3360,
    "max": 3380,
    "taxes": [
      110100,
      87650,
      51510,
      38500,
      33250,
      28000,
      22750,
      17950,
      14570,
      11200,
      7820
    ]
  },
  {
    "min": 3380,
    "max": 3400,
    "taxes": [
      112550,
      89370,
      53070,
      39950,
      33880,
      28630,
      23380,
      18350,
      14970,
      11600,
      8220
    ]
  },
  {
    "min": 3400,
    "max": 3420,
    "taxes": [
      114990,
      91080,
      54640,
      41510,
      34500,
      29250,
      24000,
      18750,
      15370,
      12000,
      8620
    ]
  },
  {
    "min": 3420,
    "max": 3440,
    "taxes": [
      117440,
      92790,
      56200,
      43080,
      35130,
      29880,
      24630,
      19380,
      15780,
      12400,
      9030
    ]
  },
  {
    "min": 3440,
    "max": 3460,
    "taxes": [
      119880,
      94880,
      57770,
      44640,
      35750,
      30500,
      25250,
      20000,
      16180,
      12800,
      9430
    ]
  },
  {
    "min": 3460,
    "max": 3480,
    "taxes": [
      122330,
      97330,
      59330,
      46210,
      36380,
      31130,
      25880,
      20630,
      16580,
      13210,
      9830
    ]
  },
  {
    "min": 3480,
    "max": 3500,
    "taxes": [
      124770,
      99770,
      60900,
      47770,
      37010,
      31760,
      26510,
      21260,
      16980,
      13610,
      10230
    ]
  },
  {
    "min": 3500,
    "max": 3520,
    "taxes": [
      127220,
      102220,
      62460,
      49340,
      37630,
      32380,
      27130,
      21880,
      17390,
      14010,
      10640
    ]
  },
  {
    "min": 3520,
    "max": 3540,
    "taxes": [
      129660,
      104660,
      64030,
      50900,
      38260,
      33010,
      27760,
      22510,
      17790,
      14410,
      11040
    ]
  },
  {
    "min": 3540,
    "max": 3560,
    "taxes": [
      132110,
      107110,
      65590,
      52460,
      39340,
      33630,
      28380,
      23130,
      18190,
      14820,
      11440
    ]
  },
  {
    "min": 3560,
    "max": 3580,
    "taxes": [
      134550,
      109550,
      67150,
      54030,
      40900,
      34260,
      29010,
      23760,
      18590,
      15220,
      11840
    ]
  },
  {
    "min": 3580,
    "max": 3600,
    "taxes": [
      137000,
      112000,
      68720,
      55590,
      42470,
      34880,
      29630,
      24380,
      19130,
      15620,
      12250
    ]
  },
  {
    "min": 3600,
    "max": 3620,
    "taxes": [
      139440,
      114440,
      70280,
      57160,
      44030,
      35510,
      30260,
      25010,
      19760,
      16020,
      12650
    ]
  },
  {
    "min": 3620,
    "max": 3640,
    "taxes": [
      141890,
      116890,
      71850,
      58720,
      45600,
      36140,
      30890,
      25640,
      20390,
      16420,
      13050
    ]
  },
  {
    "min": 3640,
    "max": 3660,
    "taxes": [
      144330,
      119330,
      73410,
      60290,
      47160,
      36760,
      31510,
      26260,
      21010,
      16830,
      13450
    ]
  },
  {
    "min": 3660,
    "max": 3680,
    "taxes": [
      146780,
      121780,
      74980,
      61850,
      48730,
      37390,
      32140,
      26890,
      21640,
      17230,
      13850
    ]
  },
  {
    "min": 3680,
    "max": 3700,
    "taxes": [
      149220,
      124220,
      76540,
      63420,
      50290,
      38010,
      32760,
      27510,
      22260,
      17630,
      14260
    ]
  },
  {
    "min": 3700,
    "max": 3720,
    "taxes": [
      151670,
      126670,
      78110,
      64980,
      51860,
      38730,
      33390,
      28140,
      22890,
      18030,
      14660
    ]
  },
  {
    "min": 3720,
    "max": 3740,
    "taxes": [
      154110,
      129110,
      79670,
      66550,
      53420,
      40300,
      34020,
      28770,
      23520,
      18440,
      15060
    ]
  },
  {
    "min": 3740,
    "max": 3760,
    "taxes": [
      156560,
      131560,
      81230,
      68110,
      54980,
      41860,
      34640,
      29390,
      24140,
      18890,
      15460
    ]
  },
  {
    "min": 3760,
    "max": 3780,
    "taxes": [
      163920,
      136090,
      84260,
      71130,
      58010,
      44880,
      35850,
      30600,
      25350,
      20100,
      16240
    ]
  },
  {
    "min": 3780,
    "max": 3800,
    "taxes": [
      166590,
      138740,
      85970,
      72850,
      59720,
      46600,
      36540,
      31290,
      26040,
      20790,
      16680
    ]
  },
  {
    "min": 3800,
    "max": 3820,
    "taxes": [
      169260,
      141400,
      87680,
      74560,
      61430,
      48310,
      37220,
      31970,
      26720,
      21470,
      17120
    ]
  },
  {
    "min": 3820,
    "max": 3840,
    "taxes": [
      171930,
      144050,
      89390,
      76270,
      63140,
      50020,
      37900,
      32650,
      27400,
      22150,
      17560
    ]
  },
  {
    "min": 3840,
    "max": 3860,
    "taxes": [
      174600,
      146710,
      91100,
      77980,
      64850,
      51730,
      38600,
      33340,
      28090,
      22840,
      18000
    ]
  },
  {
    "min": 3860,
    "max": 3880,
    "taxes": [
      177270,
      149360,
      92820,
      79690,
      66570,
      53440,
      40320,
      34020,
      28770,
      23520,
      18440
    ]
  },
  {
    "min": 3880,
    "max": 3900,
    "taxes": [
      179940,
      152020,
      94920,
      81400,
      68280,
      55150,
      42030,
      34710,
      29460,
      24210,
      18960
    ]
  },
  {
    "min": 3900,
    "max": 3920,
    "taxes": [
      182610,
      154670,
      97370,
      83110,
      69990,
      56860,
      43740,
      35390,
      30140,
      24890,
      19640
    ]
  },
  {
    "min": 3920,
    "max": 3940,
    "taxes": [
      185280,
      157330,
      99810,
      84830,
      71700,
      58580,
      45450,
      36080,
      30830,
      25580,
      20330
    ]
  },
  {
    "min": 3940,
    "max": 3960,
    "taxes": [
      187950,
      159980,
      102260,
      86540,
      73410,
      60290,
      47160,
      36760,
      31510,
      26260,
      21010
    ]
  },
  {
    "min": 3960,
    "max": 3980,
    "taxes": [
      190620,
      162640,
      104700,
      88250,
      75120,
      62000,
      48870,
      37450,
      32200,
      26950,
      21700
    ]
  },
  {
    "min": 3980,
    "max": 4000,
    "taxes": [
      193290,
      165290,
      107150,
      89960,
      76840,
      63710,
      50590,
      38130,
      32880,
      27630,
      22380
    ]
  },
  {
    "min": 4000,
    "max": 4020,
    "taxes": [
      195960,
      167950,
      109590,
      91670,
      78550,
      65420,
      52300,
      39170,
      33570,
      28320,
      23070
    ]
  },
  {
    "min": 4020,
    "max": 4040,
    "taxes": [
      198630,
      170600,
      112040,
      93380,
      80260,
      67130,
      54010,
      40880,
      34250,
      29000,
      23750
    ]
  },
  {
    "min": 4040,
    "max": 4060,
    "taxes": [
      201300,
      173260,
      114480,
      95730,
      81970,
      68840,
      55720,
      42590,
      34930,
      29680,
      24430
    ]
  },
  {
    "min": 4060,
    "max": 4080,
    "taxes": [
      203970,
      175910,
      116930,
      98180,
      83680,
      70560,
      57430,
      44310,
      35620,
      30370,
      25120
    ]
  },
  {
    "min": 4080,
    "max": 4100,
    "taxes": [
      206640,
      178570,
      119370,
      100620,
      85390,
      72270,
      59140,
      46020,
      36300,
      31050,
      25800
    ]
  },
  {
    "min": 4100,
    "max": 4120,
    "taxes": [
      209310,
      181220,
      121820,
      103070,
      87100,
      73980,
      60850,
      47730,
      36990,
      31740,
      26490
    ]
  },
  {
    "min": 4120,
    "max": 4140,
    "taxes": [
      211980,
      183880,
      124260,
      105510,
      88820,
      75690,
      62570,
      49440,
      37670,
      32420,
      27170
    ]
  },
  {
    "min": 4140,
    "max": 4160,
    "taxes": [
      214650,
      186530,
      126710,
      107960,
      90530,
      77400,
      64280,
      51150,
      38360,
      33110,
      27860
    ]
  },
  {
    "min": 4160,
    "max": 4180,
    "taxes": [
      217320,
      189190,
      129150,
      110400,
      92240,
      79110,
      65990,
      52860,
      39740,
      33790,
      28540
    ]
  },
  {
    "min": 4180,
    "max": 4200,
    "taxes": [
      219990,
      191840,
      131600,
      112850,
      94100,
      80830,
      67700,
      54580,
      41450,
      34480,
      29230
    ]
  },
  {
    "min": 4200,
    "max": 4220,
    "taxes": [
      222660,
      194500,
      134040,
      115290,
      96540,
      82540,
      69410,
      56290,
      43160,
      35160,
      29910
    ]
  },
  {
    "min": 4220,
    "max": 4240,
    "taxes": [
      225330,
      197150,
      136490,
      117740,
      98990,
      84250,
      71120,
      58000,
      44870,
      35850,
      30600
    ]
  },
  {
    "min": 4240,
    "max": 4260,
    "taxes": [
      228000,
      199810,
      138930,
      120180,
      101430,
      85960,
      72830,
      59710,
      46580,
      36530,
      31280
    ]
  },
  {
    "min": 4260,
    "max": 4280,
    "taxes": [
      230670,
      202460,
      141380,
      122630,
      103880,
      87670,
      74550,
      61420,
      48300,
      37220,
      31970
    ]
  },
  {
    "min": 4280,
    "max": 4300,
    "taxes": [
      233340,
      205120,
      143820,
      125070,
      106320,
      89380,
      76260,
      63130,
      50010,
      37900,
      32650
    ]
  },
  {
    "min": 4300,
    "max": 4320,
    "taxes": [
      236010,
      207770,
      146270,
      127520,
      108770,
      91090,
      77970,
      64840,
      51720,
      38590,
      33330
    ]
  },
  {
    "min": 4320,
    "max": 4340,
    "taxes": [
      238680,
      210430,
      148710,
      129960,
      111210,
      92810,
      79680,
      66560,
      53430,
      40310,
      34020
    ]
  },
  {
    "min": 4340,
    "max": 4360,
    "taxes": [
      241350,
      213080,
      151160,
      132410,
      113660,
      94910,
      81390,
      68270,
      55140,
      42020,
      34700
    ]
  },
  {
    "min": 4360,
    "max": 4380,
    "taxes": [
      244020,
      215740,
      153600,
      134850,
      116100,
      97350,
      83100,
      69980,
      56850,
      43730,
      35390
    ]
  },
  {
    "min": 4380,
    "max": 4400,
    "taxes": [
      246690,
      218390,
      156050,
      137300,
      118550,
      99800,
      84820,
      71690,
      58570,
      45440,
      36070
    ]
  },
  {
    "min": 4400,
    "max": 4420,
    "taxes": [
      249360,
      221050,
      158490,
      139740,
      120990,
      102240,
      86530,
      73400,
      60280,
      47150,
      36760
    ]
  },
  {
    "min": 4420,
    "max": 4440,
    "taxes": [
      252030,
      223700,
      160940,
      142190,
      123440,
      104690,
      88240,
      75110,
      61990,
      48860,
      37440
    ]
  },
  {
    "min": 4440,
    "max": 4460,
    "taxes": [
      254700,
      226360,
      163380,
      144630,
      125880,
      107130,
      89950,
      76820,
      63700,
      50570,
      38130
    ]
  },
  {
    "min": 4460,
    "max": 4480,
    "taxes": [
      257370,
      229010,
      165830,
      147080,
      128330,
      109580,
      91660,
      78540,
      65410,
      52290,
      39160
    ]
  },
  {
    "min": 4480,
    "max": 4500,
    "taxes": [
      260040,
      231670,
      168270,
      149520,
      130770,
      112020,
      93370,
      80250,
      67120,
      54000,
      40870
    ]
  },
  {
    "min": 4500,
    "max": 4520,
    "taxes": [
      262840,
      234460,
      170850,
      152100,
      133350,
      114600,
      95850,
      82050,
      68930,
      55800,
      42680
    ]
  },
  {
    "min": 4520,
    "max": 4540,
    "taxes": [
      265650,
      237250,
      173430,
      154680,
      135930,
      117180,
      98430,
      83860,
      70730,
      57610,
      44480
    ]
  },
  {
    "min": 4540,
    "max": 4560,
    "taxes": [
      268450,
      240040,
      176010,
      157260,
      138510,
      119760,
      101010,
      85670,
      72540,
      59420,
      46290
    ]
  },
  {
    "min": 4560,
    "max": 4580,
    "taxes": [
      271260,
      242830,
      178590,
      159840,
      141090,
      122340,
      103590,
      87470,
      74350,
      61220,
      48100
    ]
  },
  {
    "min": 4580,
    "max": 4600,
    "taxes": [
      276560,
      248120,
      183670,
      164920,
      146170,
      127420,
      108670,
      89920,
      76150,
      63030,
      49900
    ]
  },
  {
    "min": 4600,
    "max": 4620,
    "taxes": [
      279370,
      250910,
      186250,
      167500,
      148750,
      130000,
      111250,
      92500,
      77960,
      64830,
      51710
    ]
  },
  {
    "min": 4620,
    "max": 4640,
    "taxes": [
      282170,
      253700,
      188830,
      170080,
      151330,
      132580,
      113830,
      95080,
      79760,
      66640,
      53510
    ]
  },
  {
    "min": 4640,
    "max": 4660,
    "taxes": [
      284980,
      256490,
      191410,
      172660,
      153910,
      135160,
      116410,
      97660,
      81570,
      68450,
      55320
    ]
  },
  {
    "min": 4660,
    "max": 4680,
    "taxes": [
      287780,
      259280,
      193990,
      175240,
      156490,
      137740,
      118990,
      100240,
      83380,
      70250,
      57130
    ]
  },
  {
    "min": 4680,
    "max": 4700,
    "taxes": [
      290590,
      262070,
      196570,
      177820,
      159070,
      140320,
      121570,
      102820,
      85180,
      72060,
      58930
    ]
  },
  {
    "min": 4700,
    "max": 4720,
    "taxes": [
      293390,
      264860,
      199150,
      180400,
      161650,
      142900,
      124150,
      105400,
      86990,
      73860,
      60740
    ]
  },
  {
    "min": 4720,
    "max": 4740,
    "taxes": [
      296200,
      267650,
      201730,
      182980,
      164230,
      145480,
      126730,
      107980,
      89230,
      75670,
      62540
    ]
  },
  {
    "min": 4740,
    "max": 4760,
    "taxes": [
      299000,
      270440,
      204310,
      185560,
      166810,
      148060,
      129310,
      110560,
      91810,
      77480,
      64350
    ]
  },
  {
    "min": 4760,
    "max": 4780,
    "taxes": [
      301810,
      273230,
      206890,
      188140,
      169390,
      150640,
      131890,
      113140,
      94390,
      79280,
      66160
    ]
  },
  {
    "min": 4780,
    "max": 4800,
    "taxes": [
      304610,
      276020,
      209470,
      190720,
      171970,
      153220,
      134470,
      115720,
      96970,
      81090,
      67960
    ]
  },
  {
    "min": 4800,
    "max": 4820,
    "taxes": [
      307420,
      278810,
      212050,
      193300,
      174550,
      155800,
      137050,
      118300,
      99550,
      82890,
      69770
    ]
  },
  {
    "min": 4820,
    "max": 4840,
    "taxes": [
      310220,
      281600,
      214630,
      195880,
      177130,
      158380,
      139630,
      120880,
      102130,
      84700,
      71570
    ]
  },
  {
    "min": 4840,
    "max": 4860,
    "taxes": [
      313030,
      284390,
      217210,
      198460,
      179710,
      160960,
      142210,
      123460,
      104710,
      86510,
      73380
    ]
  },
  {
    "min": 4860,
    "max": 4880,
    "taxes": [
      315830,
      287180,
      219790,
      201040,
      182290,
      163540,
      144790,
      126040,
      107290,
      88540,
      75190
    ]
  },
  {
    "min": 4880,
    "max": 4900,
    "taxes": [
      318640,
      289970,
      222370,
      203620,
      184870,
      166120,
      147370,
      128620,
      109870,
      91120,
      76990
    ]
  },
  {
    "min": 4900,
    "max": 4920,
    "taxes": [
      321440,
      292760,
      224950,
      206200,
      187450,
      168700,
      149950,
      131200,
      112450,
      93700,
      78800
    ]
  },
  {
    "min": 4920,
    "max": 4940,
    "taxes": [
      324250,
      295550,
      227530,
      208780,
      190030,
      171280,
      152530,
      133780,
      115030,
      96280,
      80600
    ]
  },
  {
    "min": 4940,
    "max": 4960,
    "taxes": [
      327050,
      298340,
      230110,
      211360,
      192610,
      173860,
      155110,
      136360,
      117610,
      98860,
      82410
    ]
  },
  {
    "min": 4960,
    "max": 4980,
    "taxes": [
      329860,
      301130,
      232690,
      213940,
      195190,
      176440,
      157690,
      138940,
      120190,
      101440,
      84220
    ]
  },
  {
    "min": 4980,
    "max": 5000,
    "taxes": [
      332660,
      303920,
      235270,
      216520,
      197770,
      179020,
      160270,
      141520,
      122770,
      104020,
      86020
    ]
  },
  {
    "min": 5000,
    "max": 5020,
    "taxes": [
      335470,
      306710,
      237850,
      219100,
      200350,
      181600,
      162850,
      144100,
      125350,
      106600,
      87850
    ]
  },
  {
    "min": 5020,
    "max": 5040,
    "taxes": [
      338270,
      309500,
      240430,
      221680,
      202930,
      184180,
      165430,
      146680,
      127930,
      109180,
      90430
    ]
  },
  {
    "min": 5040,
    "max": 5060,
    "taxes": [
      341080,
      312290,
      243010,
      224260,
      205510,
      186760,
      168010,
      149260,
      130510,
      111760,
      93010
    ]
  },
  {
    "min": 5060,
    "max": 5080,
    "taxes": [
      343880,
      315080,
      245590,
      226840,
      208090,
      189340,
      170590,
      151840,
      133090,
      114340,
      95590
    ]
  },
  {
    "min": 5080,
    "max": 5100,
    "taxes": [
      346690,
      317870,
      248170,
      229420,
      210670,
      191920,
      173170,
      154420,
      135670,
      116920,
      98170
    ]
  },
  {
    "min": 5100,
    "max": 5120,
    "taxes": [
      349490,
      320660,
      250750,
      232000,
      213250,
      194500,
      175750,
      157000,
      138250,
      119500,
      100750
    ]
  },
  {
    "min": 5120,
    "max": 5140,
    "taxes": [
      352300,
      323450,
      253330,
      234580,
      215830,
      197080,
      178330,
      159580,
      140830,
      122080,
      103330
    ]
  },
  {
    "min": 5140,
    "max": 5160,
    "taxes": [
      355100,
      326240,
      255910,
      237160,
      218410,
      199660,
      180910,
      162160,
      143410,
      124660,
      105910
    ]
  },
  {
    "min": 5160,
    "max": 5180,
    "taxes": [
      357910,
      329030,
      258490,
      239740,
      220990,
      202240,
      183490,
      164740,
      145990,
      127240,
      108490
    ]
  },
  {
    "min": 5180,
    "max": 5200,
    "taxes": [
      360710,
      331820,
      261070,
      242320,
      223570,
      204820,
      186070,
      167320,
      148570,
      129820,
      111070
    ]
  },
  {
    "min": 5200,
    "max": 5220,
    "taxes": [
      363520,
      334610,
      263650,
      244900,
      226150,
      207400,
      188650,
      169900,
      151150,
      132400,
      113650
    ]
  },
  {
    "min": 5220,
    "max": 5240,
    "taxes": [
      366320,
      337400,
      266230,
      247480,
      228730,
      209980,
      191230,
      172480,
      153730,
      134980,
      116230
    ]
  },
  {
    "min": 5240,
    "max": 5260,
    "taxes": [
      369130,
      340190,
      268810,
      250060,
      231310,
      212560,
      193810,
      175060,
      156310,
      137560,
      118810
    ]
  },
  {
    "min": 5260,
    "max": 5280,
    "taxes": [
      371930,
      342980,
      271390,
      252640,
      233890,
      215140,
      196390,
      177640,
      158890,
      140140,
      121390
    ]
  },
  {
    "min": 5280,
    "max": 5300,
    "taxes": [
      374740,
      345770,
      273970,
      255220,
      236470,
      217720,
      198970,
      180220,
      161470,
      142720,
      123970
    ]
  },
  {
    "min": 5300,
    "max": 5320,
    "taxes": [
      377540,
      348560,
      276550,
      257800,
      239050,
      220300,
      201550,
      182800,
      164050,
      145300,
      126550
    ]
  },
  {
    "min": 5320,
    "max": 5340,
    "taxes": [
      380350,
      351350,
      279130,
      260380,
      241630,
      222880,
      204130,
      185380,
      166630,
      147880,
      129130
    ]
  },
  {
    "min": 5340,
    "max": 5360,
    "taxes": [
      383150,
      354140,
      281710,
      262960,
      244210,
      225460,
      206710,
      187960,
      169210,
      150460,
      131710
    ]
  },
  {
    "min": 5360,
    "max": 5380,
    "taxes": [
      385960,
      356930,
      284290,
      265540,
      246790,
      228040,
      209290,
      190540,
      171790,
      153040,
      134290
    ]
  },
  {
    "min": 5380,
    "max": 5400,
    "taxes": [
      388760,
      359720,
      286870,
      268120,
      249370,
      230620,
      211870,
      193120,
      174370,
      155620,
      136870
    ]
  },
  {
    "min": 5400,
    "max": 5420,
    "taxes": [
      391570,
      362510,
      289450,
      270700,
      251950,
      233200,
      214450,
      195700,
      176950,
      158200,
      139450
    ]
  },
  {
    "min": 5420,
    "max": 5440,
    "taxes": [
      394370,
      365300,
      292030,
      273280,
      254530,
      235780,
      217030,
      198280,
      179530,
      160780,
      142030
    ]
  },
  {
    "min": 5440,
    "max": 5460,
    "taxes": [
      397180,
      368090,
      294610,
      275860,
      257110,
      238360,
      219610,
      200860,
      182110,
      163360,
      144610
    ]
  },
  {
    "min": 5460,
    "max": 5480,
    "taxes": [
      399980,
      370880,
      297190,
      278440,
      259690,
      240940,
      222190,
      203440,
      184690,
      165940,
      147190
    ]
  },
  {
    "min": 5480,
    "max": 5500,
    "taxes": [
      402790,
      373670,
      299770,
      281020,
      262270,
      243520,
      224770,
      206020,
      187270,
      168520,
      149770
    ]
  },
  {
    "min": 5500,
    "max": 5520,
    "taxes": [
      405590,
      376460,
      302350,
      283600,
      264850,
      246100,
      227350,
      208600,
      189850,
      171100,
      152350
    ]
  },
  {
    "min": 5520,
    "max": 5540,
    "taxes": [
      408400,
      379250,
      304930,
      286180,
      267430,
      248680,
      229930,
      211180,
      192430,
      173680,
      154930
    ]
  },
  {
    "min": 5540,
    "max": 5560,
    "taxes": [
      411200,
      382040,
      307510,
      288760,
      270010,
      251260,
      232510,
      213760,
      195010,
      176260,
      157510
    ]
  },
  {
    "min": 5560,
    "max": 5580,
    "taxes": [
      414010,
      384830,
      310090,
      291340,
      272590,
      253840,
      235090,
      216340,
      197590,
      178840,
      160090
    ]
  },
  {
    "min": 5580,
    "max": 5600,
    "taxes": [
      416810,
      387620,
      312670,
      293920,
      275170,
      256420,
      237670,
      218920,
      200170,
      181420,
      162670
    ]
  },
  {
    "min": 5600,
    "max": 5620,
    "taxes": [
      419620,
      390410,
      315250,
      296500,
      277750,
      259000,
      240250,
      221500,
      202750,
      184000,
      165250
    ]
  },
  {
    "min": 5620,
    "max": 5640,
    "taxes": [
      422420,
      393200,
      317830,
      299080,
      280330,
      261580,
      242830,
      224080,
      205330,
      186580,
      167830
    ]
  },
  {
    "min": 5640,
    "max": 5660,
    "taxes": [
      425230,
      395990,
      320410,
      301660,
      282910,
      264160,
      245410,
      226660,
      207910,
      189160,
      170410
    ]
  },
  {
    "min": 5660,
    "max": 5680,
    "taxes": [
      428030,
      398780,
      322990,
      304240,
      285490,
      266740,
      247990,
      229240,
      210490,
      191740,
      172990
    ]
  },
  {
    "min": 5680,
    "max": 5700,
    "taxes": [
      430840,
      401570,
      325570,
      306820,
      288070,
      269320,
      250570,
      231820,
      213070,
      194320,
      175570
    ]
  },
  {
    "min": 5700,
    "max": 5720,
    "taxes": [
      433640,
      404360,
      328150,
      309400,
      290650,
      271900,
      253150,
      234400,
      215650,
      196900,
      178150
    ]
  },
  {
    "min": 5720,
    "max": 5740,
    "taxes": [
      436450,
      407150,
      330730,
      311980,
      293230,
      274480,
      255730,
      236980,
      218230,
      199480,
      180730
    ]
  },
  {
    "min": 5740,
    "max": 5760,
    "taxes": [
      439250,
      409940,
      333310,
      314560,
      295810,
      277060,
      258310,
      239560,
      220810,
      202060,
      183310
    ]
  },
  {
    "min": 5760,
    "max": 5780,
    "taxes": [
      442060,
      412730,
      335890,
      317140,
      298390,
      279640,
      260890,
      242140,
      223390,
      204640,
      185890
    ]
  },
  {
    "min": 5780,
    "max": 5800,
    "taxes": [
      444860,
      415520,
      338470,
      319720,
      300970,
      282220,
      263470,
      244720,
      225970,
      207220,
      188470
    ]
  },
  {
    "min": 5800,
    "max": 5820,
    "taxes": [
      447670,
      418310,
      341050,
      322300,
      303550,
      284800,
      266050,
      247300,
      228550,
      209800,
      191050
    ]
  },
  {
    "min": 5820,
    "max": 5840,
    "taxes": [
      450470,
      421100,
      343630,
      324880,
      306130,
      287380,
      268630,
      249880,
      231130,
      212380,
      193630
    ]
  },
  {
    "min": 5840,
    "max": 5860,
    "taxes": [
      470380,
      441000,
      372100,
      353350,
      334600,
      315850,
      297100,
      278350,
      259600,
      240850,
      222100
    ]
  },
  {
    "min": 5860,
    "max": 5880,
    "taxes": [
      475720,
      446320,
      377240,
      358490,
      339740,
      320990,
      302240,
      283490,
      264740,
      245990,
      227240
    ]
  },
  {
    "min": 5880,
    "max": 5900,
    "taxes": [
      478690,
      449140,
      379880,
      361130,
      342380,
      323630,
      304880,
      286130,
      267380,
      248630,
      229880
    ]
  },
  {
    "min": 5900,
    "max": 5920,
    "taxes": [
      483220,
      451960,
      382520,
      363770,
      345020,
      326270,
      307520,
      288770,
      270020,
      251270,
      232520
    ]
  },
  {
    "min": 5920,
    "max": 5940,
    "taxes": [
      487760,
      454780,
      385160,
      366410,
      347660,
      328910,
      310160,
      291410,
      272660,
      253910,
      235160
    ]
  },
  {
    "min": 5940,
    "max": 5960,
    "taxes": [
      492300,
      457600,
      387800,
      369050,
      350300,
      331550,
      312800,
      294050,
      275300,
      256550,
      237800
    ]
  },
  {
    "min": 5960,
    "max": 5980,
    "taxes": [
      496830,
      460420,
      390440,
      371690,
      352940,
      334190,
      315440,
      296690,
      277940,
      259190,
      240440
    ]
  },
  {
    "min": 5980,
    "max": 6000,
    "taxes": [
      501370,
      463240,
      393080,
      374330,
      355580,
      336830,
      318080,
      299330,
      280580,
      261830,
      243080
    ]
  },
  {
    "min": 6000,
    "max": 6020,
    "taxes": [
      505900,
      466060,
      395720,
      376970,
      358220,
      339470,
      320720,
      301970,
      283220,
      264470,
      245720
    ]
  },
  {
    "min": 6020,
    "max": 6040,
    "taxes": [
      510440,
      468880,
      398360,
      379610,
      360860,
      342110,
      323360,
      304610,
      285860,
      267110,
      248360
    ]
  },
  {
    "min": 6040,
    "max": 6060,
    "taxes": [
      514980,
      471700,
      401000,
      382250,
      363500,
      344750,
      326000,
      307250,
      288500,
      269750,
      251000
    ]
  },
  {
    "min": 6060,
    "max": 6080,
    "taxes": [
      519510,
      474520,
      403640,
      384890,
      366140,
      347390,
      328640,
      309890,
      291140,
      272390,
      253640
    ]
  },
  {
    "min": 6080,
    "max": 6100,
    "taxes": [
      524050,
      477340,
      406280,
      387530,
      368780,
      350030,
      331280,
      312530,
      293780,
      275030,
      256280
    ]
  },
  {
    "min": 6100,
    "max": 6120,
    "taxes": [
      528580,
      481250,
      408920,
      390170,
      371420,
      352670,
      333920,
      315170,
      296420,
      277670,
      258920
    ]
  },
  {
    "min": 6120,
    "max": 6140,
    "taxes": [
      533120,
      485760,
      411560,
      392810,
      374060,
      355310,
      336560,
      317810,
      299060,
      280310,
      261560
    ]
  },
  {
    "min": 6140,
    "max": 6160,
    "taxes": [
      537660,
      490280,
      414200,
      395450,
      376700,
      357950,
      339200,
      320450,
      301700,
      282950,
      264200
    ]
  },
  {
    "min": 6160,
    "max": 6180,
    "taxes": [
      542190,
      494790,
      416840,
      398090,
      379340,
      360590,
      341840,
      323090,
      304340,
      285590,
      266840
    ]
  },
  {
    "min": 6180,
    "max": 6200,
    "taxes": [
      546730,
      499300,
      419480,
      400730,
      381980,
      363230,
      344480,
      325730,
      306980,
      288230,
      269480
    ]
  },
  {
    "min": 6200,
    "max": 6220,
    "taxes": [
      551260,
      503810,
      422120,
      403370,
      384620,
      365870,
      347120,
      328370,
      309620,
      290870,
      272120
    ]
  },
  {
    "min": 6220,
    "max": 6240,
    "taxes": [
      555800,
      508320,
      424760,
      406010,
      387260,
      368510,
      349760,
      331010,
      312260,
      293510,
      274760
    ]
  },
  {
    "min": 6240,
    "max": 6260,
    "taxes": [
      560340,
      512840,
      427400,
      408650,
      389900,
      371150,
      352400,
      333650,
      314900,
      296150,
      277400
    ]
  },
  {
    "min": 6260,
    "max": 6280,
    "taxes": [
      564870,
      517350,
      430040,
      411290,
      392540,
      373790,
      355040,
      336290,
      317540,
      298790,
      280040
    ]
  },
  {
    "min": 6280,
    "max": 6300,
    "taxes": [
      569410,
      521860,
      432680,
      413930,
      395180,
      376430,
      357680,
      338930,
      320180,
      301430,
      282680
    ]
  },
  {
    "min": 6300,
    "max": 6320,
    "taxes": [
      573940,
      526370,
      435320,
      416570,
      397820,
      379070,
      360320,
      341570,
      322820,
      304070,
      285320
    ]
  },
  {
    "min": 6320,
    "max": 6340,
    "taxes": [
      578480,
      530880,
      437960,
      419210,
      400460,
      381710,
      362960,
      344210,
      325460,
      306710,
      287960
    ]
  },
  {
    "min": 6340,
    "max": 6360,
    "taxes": [
      583020,
      535400,
      440600,
      421850,
      403100,
      384350,
      365600,
      346850,
      328100,
      309350,
      290600
    ]
  },
  {
    "min": 6360,
    "max": 6380,
    "taxes": [
      587550,
      539910,
      443240,
      424490,
      405740,
      386990,
      368240,
      349490,
      330740,
      311990,
      293240
    ]
  },
  {
    "min": 6380,
    "max": 6400,
    "taxes": [
      592090,
      544420,
      445880,
      427130,
      408380,
      389630,
      370880,
      352130,
      333380,
      314630,
      295880
    ]
  },
  {
    "min": 6400,
    "max": 6420,
    "taxes": [
      596620,
      548930,
      448520,
      429770,
      411020,
      392270,
      373520,
      354770,
      336020,
      317270,
      298520
    ]
  },
  {
    "min": 6420,
    "max": 6440,
    "taxes": [
      601160,
      553440,
      451160,
      432410,
      413660,
      394910,
      376160,
      357410,
      338660,
      319910,
      301160
    ]
  },
  {
    "min": 6440,
    "max": 6460,
    "taxes": [
      605700,
      557960,
      453800,
      435050,
      416300,
      397550,
      378800,
      360050,
      341300,
      322550,
      303800
    ]
  },
  {
    "min": 6460,
    "max": 6480,
    "taxes": [
      610230,
      562470,
      456440,
      437690,
      418940,
      400190,
      381440,
      362690,
      343940,
      325190,
      306440
    ]
  },
  {
    "min": 6480,
    "max": 6500,
    "taxes": [
      614770,
      566980,
      459080,
      440330,
      421580,
      402830,
      384080,
      365330,
      346580,
      327830,
      309080
    ]
  },
  {
    "min": 6500,
    "max": 6520,
    "taxes": [
      619300,
      571490,
      461720,
      442970,
      424220,
      405470,
      386720,
      367970,
      349220,
      330470,
      311720
    ]
  },
  {
    "min": 6520,
    "max": 6540,
    "taxes": [
      623840,
      576000,
      464360,
      445610,
      426860,
      408110,
      389360,
      370610,
      351860,
      333110,
      314360
    ]
  },
  {
    "min": 6540,
    "max": 6560,
    "taxes": [
      628380,
      580520,
      467000,
      448250,
      429500,
      410750,
      392000,
      373250,
      354500,
      335750,
      317000
    ]
  },
  {
    "min": 6560,
    "max": 6580,
    "taxes": [
      632910,
      585030,
      469640,
      450890,
      432140,
      413390,
      394640,
      375890,
      357140,
      338390,
      319640
    ]
  },
  {
    "min": 6580,
    "max": 6600,
    "taxes": [
      637450,
      589540,
      472280,
      453530,
      434780,
      416030,
      397280,
      378530,
      359780,
      341030,
      322280
    ]
  },
  {
    "min": 6600,
    "max": 6620,
    "taxes": [
      641980,
      594050,
      474920,
      456170,
      437420,
      418670,
      399920,
      381170,
      362420,
      343670,
      324920
    ]
  },
  {
    "min": 6620,
    "max": 6640,
    "taxes": [
      646520,
      598560,
      477560,
      458810,
      440060,
      421310,
      402560,
      383810,
      365060,
      346310,
      327560
    ]
  },
  {
    "min": 6640,
    "max": 6660,
    "taxes": [
      651060,
      603080,
      481320,
      461450,
      442700,
      423950,
      405200,
      386450,
      367700,
      348950,
      330200
    ]
  },
  {
    "min": 6660,
    "max": 6680,
    "taxes": [
      655590,
      607590,
      485540,
      464090,
      445340,
      426590,
      407840,
      389090,
      370340,
      351590,
      332840
    ]
  },
  {
    "min": 6680,
    "max": 6700,
    "taxes": [
      660130,
      612100,
      489760,
      466730,
      447980,
      429230,
      410480,
      391730,
      372980,
      354230,
      335480
    ]
  },
  {
    "min": 6700,
    "max": 6720,
    "taxes": [
      664660,
      616610,
      493990,
      469370,
      450620,
      431870,
      413120,
      394370,
      375620,
      356870,
      338120
    ]
  },
  {
    "min": 6720,
    "max": 6740,
    "taxes": [
      669200,
      621120,
      498210,
      472010,
      453260,
      434510,
      415760,
      397010,
      378260,
      359510,
      340760
    ]
  },
  {
    "min": 6740,
    "max": 6760,
    "taxes": [
      673740,
      625640,
      502440,
      474650,
      455900,
      437150,
      418400,
      399650,
      380900,
      362150,
      343400
    ]
  },
  {
    "min": 6760,
    "max": 6780,
    "taxes": [
      678270,
      630150,
      506660,
      477290,
      458540,
      439790,
      421040,
      402290,
      383540,
      364790,
      346040
    ]
  },
  {
    "min": 6780,
    "max": 6800,
    "taxes": [
      682810,
      634660,
      510880,
      480880,
      461180,
      442430,
      423680,
      404930,
      386180,
      367430,
      348680
    ]
  },
  {
    "min": 6800,
    "max": 6820,
    "taxes": [
      687340,
      639170,
      515110,
      485110,
      463820,
      445070,
      426320,
      407570,
      388820,
      370070,
      351320
    ]
  },
  {
    "min": 6820,
    "max": 6840,
    "taxes": [
      691880,
      643680,
      519330,
      489330,
      466460,
      447710,
      428960,
      410210,
      391460,
      372710,
      353960
    ]
  },
  {
    "min": 6840,
    "max": 6860,
    "taxes": [
      696420,
      648200,
      523560,
      493560,
      469100,
      450350,
      431600,
      412850,
      394100,
      375350,
      356600
    ]
  },
  {
    "min": 6860,
    "max": 6880,
    "taxes": [
      700950,
      652710,
      527780,
      497780,
      471740,
      452990,
      434240,
      415490,
      396740,
      377990,
      359240
    ]
  },
  {
    "min": 6880,
    "max": 6900,
    "taxes": [
      705490,
      657220,
      532000,
      502000,
      474380,
      455630,
      436880,
      418130,
      399380,
      380630,
      361880
    ]
  },
  {
    "min": 6900,
    "max": 6920,
    "taxes": [
      710020,
      661730,
      536230,
      506230,
      477020,
      458270,
      439520,
      420770,
      402020,
      383270,
      364520
    ]
  },
  {
    "min": 6920,
    "max": 6940,
    "taxes": [
      714560,
      666240,
      540450,
      510450,
      480450,
      460910,
      442160,
      423410,
      404660,
      385910,
      367160
    ]
  },
  {
    "min": 6940,
    "max": 6960,
    "taxes": [
      719100,
      670760,
      544680,
      514680,
      484680,
      463550,
      444800,
      426050,
      407300,
      388550,
      369800
    ]
  },
  {
    "min": 6960,
    "max": 6980,
    "taxes": [
      723630,
      675270,
      548900,
      518900,
      488900,
      466190,
      447440,
      428690,
      409940,
      391190,
      372440
    ]
  },
  {
    "min": 6980,
    "max": 7000,
    "taxes": [
      728170,
      679780,
      553120,
      523120,
      493120,
      468830,
      450080,
      431330,
      412580,
      393830,
      375080
    ]
  },
  {
    "min": 7000,
    "max": 7020,
    "taxes": [
      732700,
      684290,
      557350,
      527350,
      497350,
      471470,
      452720,
      433970,
      415220,
      396470,
      377720
    ]
  },
  {
    "min": 7020,
    "max": 7040,
    "taxes": [
      737240,
      688800,
      561570,
      531570,
      501570,
      474110,
      455360,
      436610,
      417860,
      399110,
      380360
    ]
  },
  {
    "min": 7040,
    "max": 7060,
    "taxes": [
      741780,
      693320,
      565800,
      535800,
      505800,
      476750,
      458000,
      439250,
      420500,
      401750,
      383000
    ]
  },
  {
    "min": 7060,
    "max": 7080,
    "taxes": [
      746310,
      697830,
      570020,
      540020,
      510020,
      480020,
      460640,
      441890,
      423140,
      404390,
      385640
    ]
  },
  {
    "min": 7080,
    "max": 7100,
    "taxes": [
      750850,
      702340,
      574240,
      544240,
      514240,
      484240,
      463280,
      444530,
      425780,
      407030,
      388280
    ]
  },
  {
    "min": 7100,
    "max": 7120,
    "taxes": [
      755380,
      706850,
      578470,
      548470,
      518470,
      488470,
      465920,
      447170,
      428420,
      409670,
      390920
    ]
  },
  {
    "min": 7120,
    "max": 7140,
    "taxes": [
      759920,
      711360,
      582690,
      552690,
      522690,
      492690,
      468560,
      449810,
      431060,
      412310,
      393560
    ]
  },
  {
    "min": 7140,
    "max": 7160,
    "taxes": [
      764460,
      715880,
      586920,
      556920,
      526920,
      496920,
      471200,
      452450,
      433700,
      414950,
      396200
    ]
  },
  {
    "min": 7160,
    "max": 7180,
    "taxes": [
      768990,
      720390,
      591140,
      561140,
      531140,
      501140,
      473840,
      455090,
      436340,
      417590,
      398840
    ]
  },
  {
    "min": 7180,
    "max": 7200,
    "taxes": [
      773530,
      724900,
      595360,
      565360,
      535360,
      505360,
      476480,
      457730,
      438980,
      420230,
      401480
    ]
  },
  {
    "min": 7200,
    "max": 7220,
    "taxes": [
      778060,
      729410,
      599590,
      569590,
      539590,
      509590,
      479590,
      460370,
      441620,
      422870,
      404120
    ]
  },
  {
    "min": 7220,
    "max": 7240,
    "taxes": [
      782600,
      733920,
      603810,
      573810,
      543810,
      513810,
      483810,
      463010,
      444260,
      425510,
      406760
    ]
  },
  {
    "min": 7240,
    "max": 7260,
    "taxes": [
      787140,
      738440,
      608040,
      578040,
      548040,
      518040,
      488040,
      465650,
      446900,
      428150,
      409400
    ]
  },
  {
    "min": 7260,
    "max": 7280,
    "taxes": [
      791670,
      742950,
      612260,
      582260,
      552260,
      522260,
      492260,
      468290,
      449540,
      430790,
      412040
    ]
  },
  {
    "min": 7280,
    "max": 7300,
    "taxes": [
      796210,
      747460,
      616480,
      586480,
      556480,
      526480,
      496480,
      470930,
      452180,
      433430,
      414680
    ]
  },
  {
    "min": 7300,
    "max": 7320,
    "taxes": [
      800740,
      751970,
      620710,
      590710,
      560710,
      530710,
      500710,
      473570,
      454820,
      436070,
      417320
    ]
  },
  {
    "min": 7320,
    "max": 7340,
    "taxes": [
      805280,
      756480,
      624930,
      594930,
      564930,
      534930,
      504930,
      476210,
      457460,
      438710,
      419960
    ]
  },
  {
    "min": 7340,
    "max": 7360,
    "taxes": [
      809820,
      761000,
      629160,
      599160,
      569160,
      539160,
      509160,
      479160,
      460100,
      441350,
      422600
    ]
  },
  {
    "min": 7360,
    "max": 7380,
    "taxes": [
      814350,
      765510,
      633380,
      603380,
      573380,
      543380,
      513380,
      483380,
      462740,
      443990,
      425240
    ]
  },
  {
    "min": 7380,
    "max": 7400,
    "taxes": [
      818890,
      770020,
      637600,
      607600,
      577600,
      547600,
      517600,
      487600,
      465380,
      446630,
      427880
    ]
  },
  {
    "min": 7400,
    "max": 7420,
    "taxes": [
      823420,
      774530,
      641830,
      611830,
      581830,
      551830,
      521830,
      491830,
      468020,
      449270,
      430520
    ]
  },
  {
    "min": 7420,
    "max": 7440,
    "taxes": [
      827960,
      779040,
      646050,
      616050,
      586050,
      556050,
      526050,
      496050,
      470660,
      451910,
      433160
    ]
  },
  {
    "min": 7440,
    "max": 7460,
    "taxes": [
      832500,
      783560,
      650280,
      620280,
      590280,
      560280,
      530280,
      500280,
      473300,
      454550,
      435800
    ]
  },
  {
    "min": 7460,
    "max": 7480,
    "taxes": [
      837030,
      788070,
      654500,
      624500,
      594500,
      564500,
      534500,
      504500,
      475940,
      457190,
      438440
    ]
  },
  {
    "min": 7480,
    "max": 7500,
    "taxes": [
      841570,
      792580,
      658720,
      628720,
      598720,
      568720,
      538720,
      508720,
      478720,
      459830,
      441080
    ]
  },
  {
    "min": 7500,
    "max": 7520,
    "taxes": [
      846100,
      797090,
      662950,
      632950,
      602950,
      572950,
      542950,
      512950,
      482950,
      462470,
      443720
    ]
  },
  {
    "min": 7520,
    "max": 7540,
    "taxes": [
      850640,
      801600,
      667170,
      637170,
      607170,
      577170,
      547170,
      517170,
      487170,
      465110,
      446360
    ]
  },
  {
    "min": 7540,
    "max": 7560,
    "taxes": [
      855180,
      806120,
      671400,
      641400,
      611400,
      581400,
      551400,
      521400,
      491400,
      467750,
      449000
    ]
  },
  {
    "min": 7560,
    "max": 7580,
    "taxes": [
      859710,
      810630,
      675620,
      645620,
      615620,
      585620,
      555620,
      525620,
      495620,
      470390,
      451640
    ]
  },
  {
    "min": 7580,
    "max": 7600,
    "taxes": [
      864250,
      815140,
      679840,
      649840,
      619840,
      589840,
      559840,
      529840,
      499840,
      473030,
      454280
    ]
  },
  {
    "min": 7600,
    "max": 7620,
    "taxes": [
      868780,
      819650,
      684070,
      654070,
      624070,
      594070,
      564070,
      534070,
      504070,
      475670,
      456920
    ]
  },
  {
    "min": 7620,
    "max": 7640,
    "taxes": [
      873320,
      824160,
      688290,
      658290,
      628290,
      598290,
      568290,
      538290,
      508290,
      478310,
      459560
    ]
  },
  {
    "min": 7640,
    "max": 7660,
    "taxes": [
      877860,
      828680,
      692520,
      662520,
      632520,
      602520,
      572520,
      542520,
      512520,
      482520,
      462200
    ]
  },
  {
    "min": 7660,
    "max": 7680,
    "taxes": [
      882390,
      833190,
      696740,
      666740,
      636740,
      606740,
      576740,
      546740,
      516740,
      486740,
      464840
    ]
  },
  {
    "min": 7680,
    "max": 7700,
    "taxes": [
      886930,
      837700,
      700960,
      670960,
      640960,
      610960,
      580960,
      550960,
      520960,
      490960,
      467480
    ]
  },
  {
    "min": 7700,
    "max": 7720,
    "taxes": [
      891460,
      842210,
      705190,
      675190,
      645190,
      615190,
      585190,
      555190,
      525190,
      495190,
      470120
    ]
  },
  {
    "min": 7720,
    "max": 7740,
    "taxes": [
      896000,
      846720,
      709410,
      679410,
      649410,
      619410,
      589410,
      559410,
      529410,
      499410,
      472760
    ]
  },
  {
    "min": 7740,
    "max": 7760,
    "taxes": [
      900540,
      851240,
      713640,
      683640,
      653640,
      623640,
      593640,
      563640,
      533640,
      503640,
      475400
    ]
  },
  {
    "min": 7760,
    "max": 7780,
    "taxes": [
      905070,
      855750,
      717860,
      687860,
      657860,
      627860,
      597860,
      567860,
      537860,
      507860,
      478040
    ]
  },
  {
    "min": 7780,
    "max": 7800,
    "taxes": [
      909610,
      860260,
      722080,
      692080,
      662080,
      632080,
      602080,
      572080,
      542080,
      512080,
      482080
    ]
  },
  {
    "min": 7800,
    "max": 7820,
    "taxes": [
      914140,
      864770,
      726310,
      696310,
      666310,
      636310,
      606310,
      576310,
      546310,
      516310,
      486310
    ]
  },
  {
    "min": 7820,
    "max": 7840,
    "taxes": [
      918680,
      869280,
      730530,
      700530,
      670530,
      640530,
      610530,
      580530,
      550530,
      520530,
      490530
    ]
  },
  {
    "min": 7840,
    "max": 7860,
    "taxes": [
      923220,
      873800,
      734760,
      704760,
      674760,
      644760,
      614760,
      584760,
      554760,
      524760,
      494760
    ]
  },
  {
    "min": 7860,
    "max": 7880,
    "taxes": [
      927750,
      878310,
      738980,
      708980,
      678980,
      648980,
      618980,
      588980,
      558980,
      528980,
      498980
    ]
  },
  {
    "min": 7880,
    "max": 7900,
    "taxes": [
      932290,
      882820,
      743200,
      713200,
      683200,
      653200,
      623200,
      593200,
      563200,
      533200,
      503200
    ]
  },
  {
    "min": 7900,
    "max": 7920,
    "taxes": [
      936820,
      887330,
      747430,
      717430,
      687430,
      657430,
      627430,
      597430,
      567430,
      537430,
      507430
    ]
  },
  {
    "min": 7920,
    "max": 7940,
    "taxes": [
      941360,
      891840,
      751650,
      721650,
      691650,
      661650,
      631650,
      601650,
      571650,
      541650,
      511650
    ]
  },
  {
    "min": 7940,
    "max": 7960,
    "taxes": [
      945900,
      896360,
      755880,
      725880,
      695880,
      665880,
      635880,
      605880,
      575880,
      545880,
      515880
    ]
  },
  {
    "min": 7960,
    "max": 7980,
    "taxes": [
      950430,
      900870,
      760100,
      730100,
      700100,
      670100,
      640100,
      610100,
      580100,
      550100,
      520100
    ]
  },
  {
    "min": 7980,
    "max": 8000,
    "taxes": [
      954970,
      905380,
      764320,
      734320,
      704320,
      674320,
      644320,
      614320,
      584320,
      554320,
      524320
    ]
  },
  {
    "min": 8000,
    "max": 8020,
    "taxes": [
      959500,
      909890,
      768550,
      738550,
      708550,
      678550,
      648550,
      618550,
      588550,
      558550,
      528550
    ]
  },
  {
    "min": 8020,
    "max": 8040,
    "taxes": [
      964040,
      914400,
      772770,
      742770,
      712770,
      682770,
      652770,
      622770,
      592770,
      562770,
      532770
    ]
  },
  {
    "min": 8040,
    "max": 8060,
    "taxes": [
      968580,
      918920,
      777000,
      747000,
      717000,
      687000,
      657000,
      627000,
      597000,
      567000,
      537000
    ]
  },
  {
    "min": 8060,
    "max": 8080,
    "taxes": [
      973110,
      923430,
      781220,
      751220,
      721220,
      691220,
      661220,
      631220,
      601220,
      571220,
      541220
    ]
  },
  {
    "min": 8080,
    "max": 8100,
    "taxes": [
      977650,
      927940,
      785440,
      755440,
      725440,
      695440,
      665440,
      635440,
      605440,
      575440,
      545440
    ]
  },
  {
    "min": 8100,
    "max": 8120,
    "taxes": [
      982180,
      932450,
      789670,
      759670,
      729670,
      699670,
      669670,
      639670,
      609670,
      579670,
      549670
    ]
  },
  {
    "min": 8120,
    "max": 8140,
    "taxes": [
      986720,
      936960,
      793890,
      763890,
      733890,
      703890,
      673890,
      643890,
      613890,
      583890,
      553890
    ]
  },
  {
    "min": 8140,
    "max": 8160,
    "taxes": [
      991260,
      941480,
      798120,
      768120,
      738120,
      708120,
      678120,
      648120,
      618120,
      588120,
      558120
    ]
  },
  {
    "min": 8160,
    "max": 8180,
    "taxes": [
      995790,
      945990,
      802340,
      772340,
      742340,
      712340,
      682340,
      652340,
      622340,
      592340,
      562340
    ]
  },
  {
    "min": 8180,
    "max": 8200,
    "taxes": [
      1000330,
      950500,
      806560,
      776560,
      746560,
      716560,
      686560,
      656560,
      626560,
      596560,
      566560
    ]
  },
  {
    "min": 8200,
    "max": 8220,
    "taxes": [
      1004860,
      955010,
      810790,
      780790,
      750790,
      720790,
      690790,
      660790,
      630790,
      600790,
      570790
    ]
  },
  {
    "min": 8220,
    "max": 8240,
    "taxes": [
      1009400,
      959520,
      815010,
      785010,
      755010,
      725010,
      695010,
      665010,
      635010,
      605010,
      575010
    ]
  },
  {
    "min": 8240,
    "max": 8260,
    "taxes": [
      1013940,
      964040,
      819240,
      789240,
      759240,
      729240,
      699240,
      669240,
      639240,
      609240,
      579240
    ]
  },
  {
    "min": 8260,
    "max": 8280,
    "taxes": [
      1018470,
      968550,
      823460,
      793460,
      763460,
      733460,
      703460,
      673460,
      643460,
      613460,
      583460
    ]
  },
  {
    "min": 8280,
    "max": 8300,
    "taxes": [
      1023010,
      973060,
      827680,
      797680,
      767680,
      737680,
      707680,
      677680,
      647680,
      617680,
      587680
    ]
  },
  {
    "min": 8300,
    "max": 8320,
    "taxes": [
      1027540,
      977570,
      831910,
      801910,
      771910,
      741910,
      711910,
      681910,
      651910,
      621910,
      591910
    ]
  },
  {
    "min": 8320,
    "max": 8340,
    "taxes": [
      1032080,
      982080,
      836130,
      806130,
      776130,
      746130,
      716130,
      686130,
      656130,
      626130,
      596130
    ]
  },
  {
    "min": 8340,
    "max": 8360,
    "taxes": [
      1036740,
      986720,
      840480,
      810480,
      780480,
      750480,
      720480,
      690480,
      660480,
      630480,
      600480
    ]
  },
  {
    "min": 8360,
    "max": 8380,
    "taxes": [
      1041420,
      991370,
      844840,
      814840,
      784840,
      754840,
      724840,
      694840,
      664840,
      634840,
      604840
    ]
  },
  {
    "min": 8380,
    "max": 8400,
    "taxes": [
      1046100,
      996030,
      849210,
      819210,
      789210,
      759210,
      729210,
      699210,
      669210,
      639210,
      609210
    ]
  },
  {
    "min": 8400,
    "max": 8420,
    "taxes": [
      1050780,
      1000680,
      853580,
      823580,
      793580,
      763580,
      733580,
      703580,
      673580,
      643580,
      613580
    ]
  },
  {
    "min": 8420,
    "max": 8440,
    "taxes": [
      1055460,
      1005340,
      857950,
      827950,
      797950,
      767950,
      737950,
      707950,
      677950,
      647950,
      617950
    ]
  },
  {
    "min": 8440,
    "max": 8460,
    "taxes": [
      1060140,
      1010000,
      862320,
      832320,
      802320,
      772320,
      742320,
      712320,
      682320,
      652320,
      622320
    ]
  },
  {
    "min": 8460,
    "max": 8480,
    "taxes": [
      1064820,
      1014650,
      866680,
      836680,
      806680,
      776680,
      746680,
      716680,
      686680,
      656680,
      626680
    ]
  },
  {
    "min": 8480,
    "max": 8500,
    "taxes": [
      1069500,
      1019310,
      871050,
      841050,
      811050,
      781050,
      751050,
      721050,
      691050,
      661050,
      631050
    ]
  },
  {
    "min": 8500,
    "max": 8520,
    "taxes": [
      1074180,
      1023960,
      875420,
      845420,
      815420,
      785420,
      755420,
      725420,
      695420,
      665420,
      635420
    ]
  },
  {
    "min": 8520,
    "max": 8540,
    "taxes": [
      1078860,
      1028620,
      879790,
      849790,
      819790,
      789790,
      759790,
      729790,
      699790,
      669790,
      639790
    ]
  },
  {
    "min": 8540,
    "max": 8560,
    "taxes": [
      1083540,
      1033280,
      884160,
      854160,
      824160,
      794160,
      764160,
      734160,
      704160,
      674160,
      644160
    ]
  },
  {
    "min": 8560,
    "max": 8580,
    "taxes": [
      1088220,
      1037930,
      888520,
      858520,
      828520,
      798520,
      768520,
      738520,
      708520,
      678520,
      648520
    ]
  },
  {
    "min": 8580,
    "max": 8600,
    "taxes": [
      1092900,
      1042590,
      892890,
      862890,
      832890,
      802890,
      772890,
      742890,
      712890,
      682890,
      652890
    ]
  },
  {
    "min": 8600,
    "max": 8620,
    "taxes": [
      1097580,
      1047240,
      897260,
      867260,
      837260,
      807260,
      777260,
      747260,
      717260,
      687260,
      657260
    ]
  },
  {
    "min": 8620,
    "max": 8640,
    "taxes": [
      1102260,
      1051900,
      901630,
      871630,
      841630,
      811630,
      781630,
      751630,
      721630,
      691630,
      661630
    ]
  },
  {
    "min": 8640,
    "max": 8660,
    "taxes": [
      1106940,
      1056560,
      906000,
      876000,
      846000,
      816000,
      786000,
      756000,
      726000,
      696000,
      666000
    ]
  },
  {
    "min": 8660,
    "max": 8680,
    "taxes": [
      1111620,
      1061210,
      910360,
      880360,
      850360,
      820360,
      790360,
      760360,
      730360,
      700360,
      670360
    ]
  },
  {
    "min": 8680,
    "max": 8700,
    "taxes": [
      1116300,
      1065870,
      914730,
      884730,
      854730,
      824730,
      794730,
      764730,
      734730,
      704730,
      674730
    ]
  },
  {
    "min": 8700,
    "max": 8720,
    "taxes": [
      1120980,
      1070520,
      919100,
      889100,
      859100,
      829100,
      799100,
      769100,
      739100,
      709100,
      679100
    ]
  },
  {
    "min": 8720,
    "max": 8740,
    "taxes": [
      1125660,
      1075180,
      923470,
      893470,
      863470,
      833470,
      803470,
      773470,
      743470,
      713470,
      683470
    ]
  },
  {
    "min": 8740,
    "max": 8760,
    "taxes": [
      1130340,
      1079840,
      927840,
      897840,
      867840,
      837840,
      807840,
      777840,
      747840,
      717840,
      687840
    ]
  },
  {
    "min": 8760,
    "max": 8780,
    "taxes": [
      1135020,
      1084490,
      932200,
      902200,
      872200,
      842200,
      812200,
      782200,
      752200,
      722200,
      692200
    ]
  },
  {
    "min": 8780,
    "max": 8800,
    "taxes": [
      1139700,
      1089150,
      936570,
      906570,
      876570,
      846570,
      816570,
      786570,
      756570,
      726570,
      696570
    ]
  },
  {
    "min": 8800,
    "max": 8820,
    "taxes": [
      1144380,
      1093800,
      940940,
      910940,
      880940,
      850940,
      820940,
      790940,
      760940,
      730940,
      700940
    ]
  },
  {
    "min": 8820,
    "max": 8840,
    "taxes": [
      1149060,
      1098460,
      945310,
      915310,
      885310,
      855310,
      825310,
      795310,
      765310,
      735310,
      705310
    ]
  },
  {
    "min": 8840,
    "max": 8860,
    "taxes": [
      1153740,
      1103120,
      949680,
      919680,
      889680,
      859680,
      829680,
      799680,
      769680,
      739680,
      709680
    ]
  },
  {
    "min": 8860,
    "max": 8880,
    "taxes": [
      1158420,
      1107770,
      954040,
      924040,
      894040,
      864040,
      834040,
      804040,
      774040,
      744040,
      714040
    ]
  },
  {
    "min": 8880,
    "max": 8900,
    "taxes": [
      1163100,
      1112430,
      958410,
      928410,
      898410,
      868410,
      838410,
      808410,
      778410,
      748410,
      718410
    ]
  },
  {
    "min": 8900,
    "max": 8920,
    "taxes": [
      1167780,
      1117080,
      962780,
      932780,
      902780,
      872780,
      842780,
      812780,
      782780,
      752780,
      722780
    ]
  },
  {
    "min": 8920,
    "max": 8940,
    "taxes": [
      1172460,
      1121740,
      967150,
      937150,
      907150,
      877150,
      847150,
      817150,
      787150,
      757150,
      727150
    ]
  },
  {
    "min": 8940,
    "max": 8960,
    "taxes": [
      1177140,
      1126400,
      971520,
      941520,
      911520,
      881520,
      851520,
      821520,
      791520,
      761520,
      731520
    ]
  },
  {
    "min": 8960,
    "max": 8980,
    "taxes": [
      1181820,
      1131050,
      975880,
      945880,
      915880,
      885880,
      855880,
      825880,
      795880,
      765880,
      735880
    ]
  },
  {
    "min": 8980,
    "max": 9000,
    "taxes": [
      1186500,
      1135710,
      980250,
      950250,
      920250,
      890250,
      860250,
      830250,
      800250,
      770250,
      740250
    ]
  },
  {
    "min": 9000,
    "max": 9020,
    "taxes": [
      1191180,
      1140360,
      984620,
      954620,
      924620,
      894620,
      864620,
      834620,
      804620,
      774620,
      744620
    ]
  },
  {
    "min": 9020,
    "max": 9040,
    "taxes": [
      1195860,
      1145020,
      988990,
      958990,
      928990,
      898990,
      868990,
      838990,
      808990,
      778990,
      748990
    ]
  },
  {
    "min": 9040,
    "max": 9060,
    "taxes": [
      1200540,
      1149680,
      993360,
      963360,
      933360,
      903360,
      873360,
      843360,
      813360,
      783360,
      753360
    ]
  },
  {
    "min": 9060,
    "max": 9080,
    "taxes": [
      1205220,
      1154330,
      997720,
      967720,
      937720,
      907720,
      877720,
      847720,
      817720,
      787720,
      757720
    ]
  },
  {
    "min": 9080,
    "max": 9100,
    "taxes": [
      1209900,
      1158990,
      1002090,
      972090,
      942090,
      912090,
      882090,
      852090,
      822090,
      792090,
      762090
    ]
  },
  {
    "min": 9100,
    "max": 9120,
    "taxes": [
      1214580,
      1163640,
      1006460,
      976460,
      946460,
      916460,
      886460,
      856460,
      826460,
      796460,
      766460
    ]
  },
  {
    "min": 9120,
    "max": 9140,
    "taxes": [
      1219260,
      1168300,
      1010830,
      980830,
      950830,
      920830,
      890830,
      860830,
      830830,
      800830,
      770830
    ]
  },
  {
    "min": 9140,
    "max": 9160,
    "taxes": [
      1223940,
      1172960,
      1015200,
      985200,
      955200,
      925200,
      895200,
      865200,
      835200,
      805200,
      775200
    ]
  },
  {
    "min": 9160,
    "max": 9180,
    "taxes": [
      1228620,
      1177610,
      1019560,
      989560,
      959560,
      929560,
      899560,
      869560,
      839560,
      809560,
      779560
    ]
  },
  {
    "min": 9180,
    "max": 9200,
    "taxes": [
      1233300,
      1182270,
      1023930,
      993930,
      963930,
      933930,
      903930,
      873930,
      843930,
      813930,
      783930
    ]
  },
  {
    "min": 9200,
    "max": 9220,
    "taxes": [
      1237980,
      1186920,
      1028300,
      998300,
      968300,
      938300,
      908300,
      878300,
      848300,
      818300,
      788300
    ]
  },
  {
    "min": 9220,
    "max": 9240,
    "taxes": [
      1244640,
      1191580,
      1032670,
      1002670,
      972670,
      942670,
      912670,
      882670,
      852670,
      822670,
      792670
    ]
  },
  {
    "min": 9240,
    "max": 9260,
    "taxes": [
      1251470,
      1196240,
      1037040,
      1007040,
      977040,
      947040,
      917040,
      887040,
      857040,
      827040,
      797040
    ]
  },
  {
    "min": 9260,
    "max": 9280,
    "taxes": [
      1258290,
      1200890,
      1041400,
      1011400,
      981400,
      951400,
      921400,
      891400,
      861400,
      831400,
      801400
    ]
  },
  {
    "min": 9280,
    "max": 9300,
    "taxes": [
      1265120,
      1205550,
      1045770,
      1015770,
      985770,
      955770,
      925770,
      895770,
      865770,
      835770,
      805770
    ]
  },
  {
    "min": 9300,
    "max": 9320,
    "taxes": [
      1271940,
      1210200,
      1050140,
      1020140,
      990140,
      960140,
      930140,
      900140,
      870140,
      840140,
      810140
    ]
  },
  {
    "min": 9320,
    "max": 9340,
    "taxes": [
      1278770,
      1214860,
      1054510,
      1024510,
      994510,
      964510,
      934510,
      904510,
      874510,
      844510,
      814510
    ]
  },
  {
    "min": 9340,
    "max": 9360,
    "taxes": [
      1285590,
      1219520,
      1058880,
      1028880,
      998880,
      968880,
      938880,
      908880,
      878880,
      848880,
      818880
    ]
  },
  {
    "min": 9360,
    "max": 9380,
    "taxes": [
      1292420,
      1224170,
      1063240,
      1033240,
      1003240,
      973240,
      943240,
      913240,
      883240,
      853240,
      823240
    ]
  },
  {
    "min": 9380,
    "max": 9400,
    "taxes": [
      1299240,
      1228830,
      1067610,
      1037610,
      1007610,
      977610,
      947610,
      917610,
      887610,
      857610,
      827610
    ]
  },
  {
    "min": 9400,
    "max": 9420,
    "taxes": [
      1306070,
      1233480,
      1071980,
      1041980,
      1011980,
      981980,
      951980,
      921980,
      891980,
      861980,
      831980
    ]
  },
  {
    "min": 9420,
    "max": 9440,
    "taxes": [
      1312890,
      1238140,
      1076350,
      1046350,
      1016350,
      986350,
      956350,
      926350,
      896350,
      866350,
      836350
    ]
  },
  {
    "min": 9440,
    "max": 9460,
    "taxes": [
      1319720,
      1244840,
      1080720,
      1050720,
      1020720,
      990720,
      960720,
      930720,
      900720,
      870720,
      840720
    ]
  },
  {
    "min": 9460,
    "max": 9480,
    "taxes": [
      1326540,
      1251630,
      1085080,
      1055080,
      1025080,
      995080,
      965080,
      935080,
      905080,
      875080,
      845080
    ]
  },
  {
    "min": 9480,
    "max": 9500,
    "taxes": [
      1333370,
      1258420,
      1089450,
      1059450,
      1029450,
      999450,
      969450,
      939450,
      909450,
      879450,
      849450
    ]
  },
  {
    "min": 9500,
    "max": 9520,
    "taxes": [
      1340190,
      1265210,
      1093820,
      1063820,
      1033820,
      1003820,
      973820,
      943820,
      913820,
      883820,
      853820
    ]
  },
  {
    "min": 9520,
    "max": 9540,
    "taxes": [
      1347020,
      1272000,
      1098190,
      1068190,
      1038190,
      1008190,
      978190,
      948190,
      918190,
      888190,
      858190
    ]
  },
  {
    "min": 9540,
    "max": 9560,
    "taxes": [
      1353840,
      1278790,
      1102560,
      1072560,
      1042560,
      1012560,
      982560,
      952560,
      922560,
      892560,
      862560
    ]
  },
  {
    "min": 9560,
    "max": 9580,
    "taxes": [
      1360670,
      1285580,
      1106920,
      1076920,
      1046920,
      1016920,
      986920,
      956920,
      926920,
      896920,
      866920
    ]
  },
  {
    "min": 9580,
    "max": 9600,
    "taxes": [
      1367490,
      1292370,
      1111290,
      1081290,
      1051290,
      1021290,
      991290,
      961290,
      931290,
      901290,
      871290
    ]
  },
  {
    "min": 9600,
    "max": 9620,
    "taxes": [
      1374320,
      1299160,
      1115660,
      1085660,
      1055660,
      1025660,
      995660,
      965660,
      935660,
      905660,
      875660
    ]
  },
  {
    "min": 9620,
    "max": 9640,
    "taxes": [
      1381140,
      1305950,
      1120030,
      1090030,
      1060030,
      1030030,
      1000030,
      970030,
      940030,
      910030,
      880030
    ]
  },
  {
    "min": 9640,
    "max": 9660,
    "taxes": [
      1387970,
      1312740,
      1124400,
      1094400,
      1064400,
      1034400,
      1004400,
      974400,
      944400,
      914400,
      884400
    ]
  },
  {
    "min": 9660,
    "max": 9680,
    "taxes": [
      1394790,
      1319530,
      1128760,
      1098760,
      1068760,
      1038760,
      1008760,
      978760,
      948760,
      918760,
      888760
    ]
  },
  {
    "min": 9680,
    "max": 9700,
    "taxes": [
      1401620,
      1326320,
      1133130,
      1103130,
      1073130,
      1043130,
      1013130,
      983130,
      953130,
      923130,
      893130
    ]
  },
  {
    "min": 9700,
    "max": 9720,
    "taxes": [
      1408440,
      1333110,
      1137500,
      1107500,
      1077500,
      1047500,
      1017500,
      987500,
      957500,
      927500,
      897500
    ]
  },
  {
    "min": 9720,
    "max": 9740,
    "taxes": [
      1415270,
      1339900,
      1141870,
      1111870,
      1081870,
      1051870,
      1021870,
      991870,
      961870,
      931870,
      901870
    ]
  },
  {
    "min": 9740,
    "max": 9760,
    "taxes": [
      1422090,
      1346690,
      1146240,
      1116240,
      1086240,
      1056240,
      1026240,
      996240,
      966240,
      936240,
      906240
    ]
  },
  {
    "min": 9760,
    "max": 9780,
    "taxes": [
      1428920,
      1353480,
      1150600,
      1120600,
      1090600,
      1060600,
      1030600,
      1000600,
      970600,
      940600,
      910600
    ]
  },
  {
    "min": 9780,
    "max": 9800,
    "taxes": [
      1435740,
      1360270,
      1154970,
      1124970,
      1094970,
      1064970,
      1034970,
      1004970,
      974970,
      944970,
      914970
    ]
  },
  {
    "min": 9800,
    "max": 9820,
    "taxes": [
      1442570,
      1367060,
      1159340,
      1129340,
      1099340,
      1069340,
      1039340,
      1009340,
      979340,
      949340,
      919340
    ]
  },
  {
    "min": 9820,
    "max": 9840,
    "taxes": [
      1449390,
      1373850,
      1163710,
      1133710,
      1103710,
      1073710,
      1043710,
      1013710,
      983710,
      953710,
      923710
    ]
  },
  {
    "min": 9840,
    "max": 9860,
    "taxes": [
      1456220,
      1380640,
      1168080,
      1138080,
      1108080,
      1078080,
      1048080,
      1018080,
      988080,
      958080,
      928080
    ]
  },
  {
    "min": 9860,
    "max": 9880,
    "taxes": [
      1463040,
      1387430,
      1172440,
      1142440,
      1112440,
      1082440,
      1052440,
      1022440,
      992440,
      962440,
      932440
    ]
  },
  {
    "min": 9880,
    "max": 9900,
    "taxes": [
      1469870,
      1394220,
      1176810,
      1146810,
      1116810,
      1086810,
      1056810,
      1026810,
      996810,
      966810,
      936810
    ]
  },
  {
    "min": 9900,
    "max": 9920,
    "taxes": [
      1476690,
      1401010,
      1181180,
      1151180,
      1121180,
      1091180,
      1061180,
      1031180,
      1001180,
      971180,
      941180
    ]
  },
  {
    "min": 9920,
    "max": 9940,
    "taxes": [
      1483520,
      1407800,
      1185550,
      1155550,
      1125550,
      1095550,
      1065550,
      1035550,
      1005550,
      975550,
      945550
    ]
  },
  {
    "min": 9940,
    "max": 9960,
    "taxes": [
      1490340,
      1414590,
      1189920,
      1159920,
      1129920,
      1099920,
      1069920,
      1039920,
      1009920,
      979920,
      949920
    ]
  },
  {
    "min": 9960,
    "max": 9980,
    "taxes": [
      1497170,
      1421380,
      1194280,
      1164280,
      1134280,
      1104280,
      1074280,
      1044280,
      1014280,
      984280,
      954280
    ]
  },
  {
    "min": 9980,
    "max": 10000,
    "taxes": [
      1503990,
      1428170,
      1198650,
      1168650,
      1138650,
      1108650,
      1078650,
      1048650,
      1018650,
      988650,
      958650
    ]
  },
  {
    "min": 10000,
    "max": 0,
    "taxes": [
      1507400,
      1431570,
      1200840,
      1170840,
      1140840,
      1110840,
      1080840,
      1050840,
      1020840,
      990840,
      960840
    ]
  },
  {
    "min": 10000,
    "max": 0,
    "taxes": [
      10000000,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 14000,
    "max": 0,
    "taxes": [
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 28000,
    "max": 0,
    "taxes": [
      10000,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 30000,
    "max": 0,
    "taxes": [
      10000,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 45000,
    "max": 0,
    "taxes": [
      10000,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  },
  {
    "min": 87000,
    "max": 0,
    "taxes": [
      10000,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]
  }
  ];
